export default defineNuxtPlugin(() => ({
    legacy: false,
    locale: 'it',
    messages: {
        it: {
          altre_azioni: "Altre azioni",
          allegato_caricato_con_successo: "Allegato caricato",
          allegati_referto: "Allegati referto",
          carica_allegato: "Carica allegato",
          allegato: "Allegato",
          allegati: "Allegati",
          nome_file: "Nome file",
          allegato_referto: "Allegato referto",
          nessun_allegato: "Nessun allegato presente",
          allegato_eliminato_con_successo: "Allegato eliminato",
          durata_appuntamento: 'Durata appuntamento',
          data_ora_consegna_referto: 'Data e ora consegna referto',
            tipologia_paziente: 'Tipologia Paziente',
            maggiorenne: 'Maggiorenne',
            minorenne: 'Minorenne',
            consenso_informato: 'Consenso Informato',
            ripristina: 'Ripristina',
            massimizza: 'Massimizza',
            luogo_visita: 'Luogo visita',
            trap: 'Trap - Fleboterapia Rigenerativa Tridimensionale Ambulatoriale',
            agopuntura: 'Agopuntura',
            estetica: 'Estetica',
            infiltrazioni: 'Infiltrazioni',
            ozono_terapia: 'Ozono Terapia',
            acqualix: 'Acqualix',
            dettagli_consenso_acqualix: 'Dettagli consenso Acqualix',
            dettagli_consenso_trap: 'Dettagli consenso TRAP',
            conferma_rimozione_firma:
                'Sei sicuro di voler rimuovere la firma? Per confermare la rimozione, sarà necessario aggiornare l\'anagrafica del medico tramite il bottone "Aggiorna".',
            rimuovi_firma: 'Rimuovi firma',
            firma_rimossa: 'Firma rimossa con successo',
            firma_paziente_non_presente: 'Firma paziente non presente',
            creazione_in_corso: 'Creazione in corso...',
            effetti_collaterali_inerenti: 'Effetti collaterali inerenti',
            data_primo_intervento: 'Data primo intervento',
            data_visita: 'Data visita',
            mediante: 'Mediante',
            dettagli_consenso_estetica: 'Dettagli consenso Estetica',
            dettagli_consenso_agopuntura: 'Dettagli consenso Agopuntura',
            dettagli_consenso_infiltrazioni: 'Dettagli consenso Infiltrazioni',
            dettagli_consenso_ozono_terapia: 'Dettagli consenso Ozono terapia',
            stampa_consenso: 'Stampa consenso',
            scarica_consenso: 'Scarica consenso',
            visualizza_consenso: 'Visualizza consenso',
            anomalie_estetiche: 'Anomalie estetiche',
            farmaco: 'Farmaco',
            cortisone: 'Cortisone',
            acido_ialuronico: 'Acido ialuronico',
            sede: 'Sede',
            ginocchio: 'Ginocchio',
            spalla: 'Spalla',
            caviglia: 'Caviglia',
            piede: 'Piede',
            dx: 'Dx',
            sx: 'Sx',
            bilaterale: 'Bilaterale',
            nome_paziente: 'Nome paziente',
            cognome_paziente: 'Cognome paziente',
            seleziona_medico: 'Seleziona medico',
            menopausa: 'Menopausa',
            menopausa_anni: 'Menopausa anni',
            nome_attrezzatura: 'Nome attrezzatura',
            data_ultima_manutenzione: 'Data ultima manutenzione',
            numero_matricola: 'Numero matricola',
            genera_e_stampa_pdf: 'Genera e stampa PDF',
            tipologia_iscrizione_ordine: 'Tipologia iscrizione ordine',
            aggiungi_anamnesi: 'Aggiungi anamnesi',
            numero_iscrizione_ordine: 'Numero iscrizione ordine',
            resoconto_in_firma_medici: 'Esito riprodotto nella firma dei medici',
            informativa_privacy: 'Informativa Privacy',
            firma: 'Firma',
            altre_allergie: 'Allergie non elencate',
            descrizione_elenco_strumenti: 'Descrizione Elenco Strumenti',
            elenco_strumenti: 'Elenco Strumenti',
            conferma_aggiornamento_dati_paziente_consenso_estetica:
                "Sono stati modificati dei dati anagrafici derivati dal paziente. Vuoi aggiornare l'anagrafica del paziente con i nuovi dati?",
            seleziona_righe_prima_pazienti:
                'Per poter esportare degli elementi, prima seleziona una o più righe tramite la casella sulla sinistra della tabella!',
            esporta_pdf_pazienti: 'Esporta PDF Pazienti',
            aggiorna_carta_intestata: 'Aggiorna carta intestata',
            salva_carta_intestata: 'Salva carta intestata',
            carta_intestata_aggiornato_con_successo: 'Carta intestata aggiornata con successo',
            errore_aggiornamento_carta_intestata:
                "Errore durante l'aggiornamento della carta intestata",
            nuova_carta_intestata: 'Nuova carta intestata',
            data_carta_intestata: 'Data carta intestata',
            menu_carta_intestata: 'Carta intestata',
            menu_carta_intestata_tooltip: 'Carta intestata',
            tipologia_consenso: 'Tipologia consenso',
            firma_paziente: 'Firma paziente',
            immagini_etichette_farmaci: 'Immagini delle etichette dei farmaci',
            nessuna_immagine_caricata: 'Nessuna immagine caricata',
            nominativo_paziente: 'Nominativo paziente',
            nominativo_medico: 'Nominativo medico',
            paziente_maggiorenne: 'Paziente maggiorenne',
            createdAt: 'Momento creazione',
            codice_giftcard: 'Codice Giftcard',
            tipo_visita: 'Tipo visita',
            tipologia_accesso: 'Tipo di accesso',
            strumentale: 'Visita con strumenti',
            menu_consensi_informati_tooltip: 'Consensi informati',
            menu_consensi_informati: 'Consensi informati',
            menu_tipologie_accesso_tooltip: 'Anagrafiche - Tipologie di accesso',
            menu_tipologie_accesso: 'Tipologie di accesso',
            genera: 'Genera',
            genera_e_scarica: 'Genera e scarica',
            numero_civico: 'Numero civico',
            tutore: 'Tutore',
            usa_un_tutore_gia_registrato:
                'Puoi usare un tutore già registrato così da velocizzare il processo.',
            nato_a: 'Nato a',
            nato_il: 'Nato il',
            riepilogo: 'Riepilogo',
            qualita: 'Qualità di',
            seleziona_tutore_esistente: 'Seleziona un tutore esistente',
            ripetibile: 'Ripeti ogni anno',
            aggiornamento_privacy_necessario: 'Aggiornamento privacy necessario!',
            paziente_minorenne: 'Paziente minorenne',
            informativa_privacy: 'Informativa Privacy',
            informativa_privacy_disabilitata:
                "L'informativa privacy è disabilitata in quanto il codice fiscale non è salvato all'interno del database. Salva l'anagrafica del paziente per poter registrare l'informativa privacy.",
            menu_pazienti: 'Pazienti',
            seleziona_paziente: 'Seleziona paziente',
            Accredito: 'Accredito',
            accredito: 'Accredito',
            Addebito: 'Addebito',
            addebito: 'Addebito',
            trasferimento: 'Trasferimento a',
            Trasferimento: 'Trasferimento a',
            errore_generico: 'Errore generico, riprova più tardi',
            torna_al_login: 'Torna al login',
            generatore_password: 'Generatore Password',
            codice_tramite_email: 'Codice inviato tramite email',
            recupera_password: 'Recupera Password',
            inserisci_Username_per_recupero_passoword:
                'Inserisci il tuo username per recuperare la password',
            inserisci_Username: 'Inserisci Username',
            verifica_il_codice: 'Verifica il codice',
            resetta_password: 'Resetta Password',
            attenzione_capslock_attivo: 'Attenzione, il tasto CAPS LOCK è attivo!',
            strumenti_utilizzati: 'Strumenti utilizzati',
            non_richiesto: 'Non richiesto',
            strumenti: 'Strumenti',
            aggiungi_alla_corrente: 'Aggiungi alla corrente',
            sostituisci_anamnesi_corrente: 'Sostituisci anamnesi corrente',
            menu_visite_strumentali: 'Elenco Strumenti',
            menu_visite_strumentali_tooltip: 'Anagrafiche - Elenco Strumenti',
            qrcode: 'QR Code',
            archivio_elimina_selezionati: 'Elimina selezionati',
            menu_utilita_archivio_tooltip: 'Utilità - Archivio',
            menu_utilita_archivio: 'Archivio',
            altro: 'Altro',
            evento: 'Evento',
            matrimonio: 'Matrimonio',
            compleanno: 'Compleanno',
            anniversario: 'Anniversario',
            battesimo: 'Battesimo',
            cresima: 'Cresima',
            comunione: 'Comunione',
            titolo: 'Titolo',
            descrizione_evento_generico: 'Descrizione evento generico',
            eventi_generici: 'Eventi generici',
            crea_evento_generico: 'Crea evento generico',
            inserisci_disponibilita_medici: 'Inserisci disponibilità operatori',
            per_altro: 'Altro',
            esame_strumentale: 'Esame strumentale',
            crea_paziente: 'Crea Paziente',
            configurazione_agenda_salvata: 'Configurazione agenda salvata con successo!',
            impossibile_salvare_configurazione_agenda:
                "Impossibile salvare la configurazione dell'agenda. Riprova.",
            data_inizio_contratto: 'Data inizio contratto',
            data_fine_contratto: 'Data fine contratto',
            tipo_contratto: 'Tipo contratto',
            contratto_a_tempo_indeterminato: 'Contratto a tempo indeterminato',
            scadenza_rc: 'Scadenza RC',
            tutte_le_strutture: 'Tutte le strutture',
            medico_selezionato: 'Operatore:',
            settimanale: 'Settimanale',
            tutti_i_medici: 'Tutti gli operatori',
            giornaliera: 'Giornaliera',
            vista: 'Vista:',
            aggiungi_appuntamento: 'Aggiungi Appuntamento',
            giornata_libera: 'Giornata libera!',
            nessun_appuntamento_programmato_per: 'Nessun appuntamento programmato per',
            prossimi_appuntamenti: 'Prossimi Appuntamenti',
            prossimi: 'Prossimi',
            struttura_selezionata: 'Struttura:',
            totali: 'Totali',
            timeline_giornaliera: 'Timeline Giornaliera',
            appuntamenti: 'Appuntamenti',
            nuova_disponibilita: 'Nuova disponibilità',
            date_disponibilita: 'Date disponibilità',
            impossibile_cancellare_disponibilita_con_appuntamenti:
                'Impossibile cancellare la disponibilità perché ci sono appuntamenti associati',
            crea_appuntamento: 'Crea appuntamento',
            elimina_disponibilita: 'Elimina disponibilità',
            firmato: 'Firmato',
            resetta_form: 'Resetta form',
            confermi_di_voler_salvare_le_disponibilita:
                'Confermi di voler salvare le disponibilità selezionate?',
            indica: 'Indica disponibilità',
            nessuna_disponibilita_trovata: 'Nessuna disponibilità trovata',
            firma_medico: 'Firma medico',
            accesso_negato: 'Accesso negato',
            totale_appuntamenti: 'Totale appuntamenti',
            no_permessi_spostamento_appuntamento:
                'Non hai i permessi per spostare questo appuntamento',
            no_permessi_appuntamento: 'Non hai i permessi per modificare questo appuntamento',
            seleziona_medico_per_visualizzare_disponibilita:
                'Seleziona un medico per visualizzare le sue disponibilità',
            disponibilita_medici: 'Disponibilità operatori',
            aborto: 'Aborto',
            quanti_aborti: 'Quanti aborti',
            tipologia_transazione: 'Tipologia transazione',
            giftcard: 'Giftcard',
            firma_non_presente: 'Firma non presente',
            menu_risorse: 'Elenco personale',
            credito_attuale: 'Credito attuale',
            aggiunta: 'Aggiunta',
            sottrazione: 'Sottrazione',
            credito_residuo_dopo_operazione: 'Credito residuo dopo operazione',
            calcolo_automatico_del_nuovo_saldo: 'Calcolo automatico del nuovo saldo',
            paese_nascita: 'Paese di Nascita',
            campo_obbligatorio: 'Campo obbligatorio',
            importo: 'Importo',
            conferma_inserimento_transazione: 'Conferma inserimento transazione',
            saldo_pre_transazione: 'Saldo pre-transazione',
            saldo_post_transazione: 'Saldo post-transazione',
            resoconto_transazioni: 'Resoconto transazioni',
            aggiungi_transazione: 'Aggiungi transazione',
            registra_firma: 'Registra firma',
            attendendo_firma_dispositivo: 'Attendere firma dispositivo...',
            cambia_firma: 'Cambia firma',
            nessuna_transazione: 'Nessuna transazione',
            nessuna_transazione_giftcard_registrata: 'Nessuna transazione giftcard registrata',
            inserimento_eseguito: 'Inserimento eseguito con successo!',
            stampa: 'Stampa',
            tipo: 'Tipo',
            medici: 'Operatori',
            residenza: 'Residenza',
            importa_excel: 'Importa Excel',
            elenco_specialisti: 'Elenco Personale',
            menu_elenco_personale: 'Elenco Personale',
            menu_elenco_personale_tooltip: 'Anagrafiche - Elenco Personale',
            salva_appuntamento: 'Salva Appuntamento',
            crea_referto: 'Crea Referto',
            aggiunto: 'Aggiunto',
            prestazioni_aggiunte: '{prestazione} nuova prestazione aggiunta',
            prestazioni_gia_presenti: '{prestazione} è già presente nella lista',
            prestazioni: 'Prestazioni',
            vai_ad_oggi: 'Vai ad Oggi',
            ricarica_eventi: 'Ricarica Eventi',
            calendario: 'Calendario',
            agenda: 'Agenda',
            quanti: 'Quanti?',
            denti_amalgama: 'Amalgama',
            denti_otturazioni: 'Otturazioni',
            denti_piombature: 'Piombature',
            denti_altro: 'Altro',
            gusti_desc: 'Gusti che preferisci',
            gusti: 'Gusti',
            alimentazione: 'Alimentazione',
            tatuaggi: 'Tatuaggi',
            pressione_arteriosa: 'Pressione Arteriosa',
            salute_dentale: 'Salute Dentale',
            a: 'a',
            aggiungi: 'Aggiungi',
            aggiungi_note: 'Aggiungi note',
            aggiorna: 'Aggiorna',
            aggiorna_tabella: 'Aggiorna la tabella',
            aggiornamento_eseguito: 'Aggiornamento eseguito con successo!',
            anamnesi: 'Anamnesi',
            anno: 'Anno',
            annulla: 'Annulla',
            annulla_modifica: 'Annulla modifica',
            autenticazione_2FA: 'Autenticazione 2FA',
            avvia_timer: 'Avvia timer',
            avviso_date_con_date_disabilitate:
                'In caso il range di date selezionato comprenda delle date disabilitate, il sistema andrà a generare tante associazioni quanti sono i range di date che vengono trovati.',
            azioni: 'Azioni',
            benvenuto_descrizione: 'Gestione e pianificazione commesse',
            benvenuto_titolo: 'Planner Bee.p',
            benvenuto_utente: 'Benvenuto',
            recapito_emergenza: "Contatto d'emergenza",
            calcola_data_fine: 'Calcola data fine stimata',
            calendario: 'Calendario',
            cambia_immagine: 'Cambia immagine',
            cambia_password: 'Cambia password',
            cambia_tema: 'Cambia tema',
            cambio_lingua: 'CAMBIO LINGUA IN CORSO...',
            campo_richiesto: 'Campo richiesto',
            caricamento_dati: 'Caricamento dei dati in corso...',
            categorie: 'Categorie',
            categoria: 'Categoria',
            tipologia: 'Tipologia Operatori',
            cerca: 'Cerca...',
            cerca_appuntamenti: 'Cerca Appuntamenti',
            cerca_per_nome_cognome: 'Cerca per nome o cognome...',
            aliquota_iva: 'Aliquota IVA',
            descrizione_aliquota_iva: 'Descrizione Aliquota IVA',
            prezzo_lordo: 'Prezzo Lordo',
            prezzo_di_acquisto: 'Prezzo di Acquisto',
            giacenza: 'Giacenza',
            extra: 'Extra',
            paziente: 'Paziente',
            registra_nuovo_paziente: 'Registra nuovo paziente',
            ora: 'Ora',
            medico: 'Operatore',
            struttura: 'Struttura',
            tipologia_visita: 'Tipologia Visita',
            data_creazione: 'Data Creazione',
            data_creazione: 'Data Creazione',
            prezzo_lordo: 'Prezzo Lordo',
            udm: 'Unità di Misura',
            chiudi: 'Chiudi',
            cliente: 'Cliente',
            codice: 'Codice',
            codice_email: 'Codice via email',
            partita_iva: 'Partita IVA',
            codice_sdi: 'Codice SDI',
            pec: 'PEC',
            peso: 'Peso',
            attuale_peso: 'Attuale Peso',
            altezza: 'Altezza',
            altezza_precisa: 'Altezza in cm',
            circonferenza_polso: 'Circonferenza polso in cm',
            circonferenza_addome: 'Circonferenza addome in cm',
            gruppo_sanguigno: 'Gruppo sanguigno',
            sport: 'Fai sport',
            sport_quali: 'Quali sport?',
            sport_frequenza: 'Frequenza sportiva',
            regime_alimentare: 'Regime alimentare',
            regime_alimentare_altro: 'Altro regime alimentare',
            alimentazione_e_idratazione: 'Alimentazione e idratazione',
            rapporto_corpo_desc: 'Hai un buon rapporto con il tuo corpo?',
            rapporto_corpo: 'Rapporto con il corpo',
            capelli_desc: 'I capelli hanno subito trattamento colorante, tinta, altro?',
            capelli_descrizione: 'Descrizione trattamento capelli',
            acqua: 'Acqua',
            iban: 'IBAN',
            codice_autenticazione: 'Codice di autenticazione',
            codice_inviato: 'Codice inviato! Controlla la tua email per continuare.',
            codice_obbligatorio: 'Il codice è obbligatorio!',
            codice_recupera_password_verificato:
                "Codice verificato correttamente, procedi con l'inserimento della nuova password",
            codice_testo:
                'Inserisci il codice che ti è stato inviato tramite e-mail prima della scadenza del tempo',
            cognome: 'Cognome',
            colore: 'Colore',
            collaboratori_esterni: 'Collaboratori esterni',
            commessa: 'Commessa',
            esporta_excel: 'Esporta excel',
            transazioni_disponibili_dopo_creazione:
                'Le transazioni risulteranno disponibili dopo la creazione',
            inserisci_saldo_iniziale_o_lascia_vuoto:
                'Al momento, inserisci il saldo iniziale del paziente oppure lascia vuoto per impostare €0,00',
            commessa_duplicata: 'Commessa duplicata con successo!',
            commessa_eliminata: 'Commessa eliminata con successo!',
            commessa_ricevuta: 'Commessa ricevuta',
            commessa_risorsa_aggiornata: 'Commessa aggiornata con successo!',
            commesse_importate: 'Commesse importate con successo',
            concludi: 'Concludi',
            conferma: 'Conferma',
            conferma_eliminazione: 'Sicuro di voler eliminare i dati selezionati?',
            conferma_eliminazione_transazione:
                'Sicuro di voler eliminare la transazione? Così facendo verrà solamente eliminata la transazione, il credito residuo non verrà modificato.',
            costo_finale: 'Costo finale',
            crea: 'Crea',
            creatoIl: 'Creato il',
            creazione_eseguita: 'Creazione eseguita con successo!',
            data: 'Data',
            data_fine: 'Data fine',
            data_fine_maggiore_data_inizio:
                'La data di fine deve essere maggiore della data di inizio',
            data_fine_stimata: 'Data fine stimata',
            data_inizio: 'Data inizio',
            data_intervento: 'Data intervento',
            data_nascita: 'Data di nascita',
            luogo_nascita: 'Luogo di nascita',
            provincia_nascita: 'Provincia di nascita',
            stato_nascita: 'Paese di nascita',
            data_ultimo_login: 'Ultimo login',
            dati_non_disponibili: 'Dati non disponibili',
            dati_personali: 'Dati personali',
            da_pianificare: 'Da pianificare',
            denominazione: 'Denominazione',
            descrizione: 'Descrizione',
            dettagli_base: 'Dettagli base',
            di: 'di',
            dipendente_cliente: 'Dipendente cliente',
            durata_attuale: 'Ore attuali',
            durata_giornata_lavorativa: 'Durata giornata lavorativa',
            durata_prevista: 'Ore previste',
            duplica_commessa: 'Duplica commessa',
            esporta: 'Esporta',
            email: 'Email',
            emailResetPassInviata: "Email per reset password inviata all'utente specificato.",
            email_cliente: 'Email cliente',
            email_invio_rapportino: 'Email invio rapportino',
            elimina: 'Elimina',
            elimina_commessa: 'Elimina commessa',
            errore: 'Errore!',
            errore_generazione_qr: 'Errore generazione QR!',
            error_effettua_login: 'Effettua il login per continuare',
            error_sottotitolo_401:
                "<span>Ci dispiace, ma non hai i permessi necessari per completare l'operazione. <br/>Riprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione. <br/>Grazie per la tua comprensione e pazienza.</span>",
            error_sottotitolo_404:
                "<span>Ci scusiamo, ma la pagina che stai cercando non è disponibile o è stata spostata. <br/>Verifica l'URL e assicurati che sia corretto. <br/>Se il problema persiste, potrebbe essere dovuto a un link obsoleto o a una risorsa eliminata.</span>",
            error_sottotitolo_generale:
                "<span>Ci dispiace, si è verificato un errore imprevisto durante l'operazione. <br/>Riprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione. <br/>Grazie per la tua comprensione e pazienza.</span>",
            error_titolo_401: 'Non autorizzato',
            error_titolo_404: 'Pagina non trovata',
            error_titolo_generale: 'Errore riscontrato',
            error_torna_pagina_iniziale: 'Torna alla pagina iniziale',
            favorite_page_pagina_rimossa: 'Pagina rimossa dai preferiti',
            ferma_timer: 'Ferma timer',
            file_e_documenti: 'File e documenti',
            file_troppo_grande: 'File troppo grande',
            fornitura: 'Fornitura',
            genera_password: 'Genera password',
            genera_qr: 'Genera QR',
            gestione_orari: 'Gestione orari',
            grafico: 'Grafico',
            id: 'ID',
            immagine_profilo: 'Immagine profilo',
            immagine_profilo_aggiornata: 'Immagine profilo aggiornata con successo!',
            importa: 'Importa',
            inattivita_descrizione_1: "È stata rilevata un'inattività prolungata.",
            inattivita_descrizione_2: 'Per motivi di sicurezza sei stato disconnesso.',
            inattivita_titolo: 'Inattività rilevata!',
            indirizzo_ip: 'Indirizzo IP',
            indirizzo_luogo_intervento: 'Indirizzo luogo intervento',
            informazione: 'Informazione',
            inserisci_mail_valida: 'Inserisci una mail valida',
            invia_credenziali: 'Invia credenziali tramite e-mail',
            invia_file: 'Invia file',
            invia_rapportino: 'Invia rapportino',
            inviata_amministrazione: "Inviata all'amministrazione",
            inviata_cliente: 'Inviata al cliente',
            km_percorsi: 'Km percorsi',
            livello: 'Livello',
            lista: 'Lista',
            completa_profilo: 'Completa tutti i campi per continuare',
            login_aggiorna_accedi: 'Aggiorna e accedi',
            login_attendi: 'Attendi...',
            login_attendi_riprova: 'Attendi per riprovare!',
            login_benvenuto: 'Benvenuto!',
            login_campo_non_sicuro: 'Campo non sicuro!',
            login_campi_obbligatori: 'Inserire sia username che password per continuare',
            login_codice_scaduto: 'Codice scaduto! riprova per continuare',
            login_conferma_password: 'Conferma password',
            login_nuova_password: 'Nuova password',
            login_controlla_mail: 'Controllare le email per continuare',
            login_effetta_accesso: "Effettua l'accesso",
            login_email_reset_pass_inviata:
                "Email per reset password inviata all'utente specificato.",
            login_livello_sicurezza_password: 'Livello di sicurezza password',
            login_password: 'Password',
            modifica_password: 'Modifica Password',
            login_password_dimenticata: 'Password dimenticata?',
            login_password_non_uguali: 'Le password non corrispondono',
            login_reset_password: 'Resetta la password',
            login_scegli_autenticazione: 'Seleziona il metodo di autenticazione',
            login_submit_text: 'Accedi',
            login_suggerimenti_password: 'Suggerimenti password',
            login_suggerimenti_password_1:
                'La password deve contenere almeno una lettera minuscola',
            login_suggerimenti_password_2:
                'La password deve contenere almeno una lettera maiuscola',
            login_suggerimenti_password_3: 'La password deve contenere almeno un numero',
            login_suggerimenti_password_4:
                'La password deve contenere almeno uno carattere speciale',
            login_suggerimenti_password_5: 'La password deve contenere almeno 8 caratteri',
            login_timeout_codice: 'Codice di verifica scaduto',
            login_troppe_richieste: 'Hai effettuato troppe richieste!',
            login_usa_password: 'Usa la tua password',
            login_username: 'Username',
            login_username_reset_password:
                "Inserisci l'username per cui si vuole richiedere il reset password nel campo 'username'.",
            login_utente_non_trovato: "Impossibile trovare l'utente inserito!",
            logout_conferma_disconnessione: 'Conferma',
            logout_disconnetti: 'Disconnetti',
            logout_disconnessione: 'Disconnessione',
            logout_messaggio_disconnessione: 'Sicuro di voler effettuare la disconnessione?',
            luogo_intervento: 'Luogo intervento',
            menu_amministratori: 'Amministratori',
            menu_amministratori_tooltip: 'Anagrafiche - Amministratori',
            menu_medici: 'Operatori',
            menu_medici_tooltip: 'Anagrafiche - Operatori',
            menu_anagrafiche: 'Anagrafiche',
            menu_categorie_commesse: 'Categorie commesse',
            menu_categorie_commesse_tooltip: 'Anagrafiche - Categorie commesse',
            menu_tipologia_operatori: 'Tipologia Operatori',
            menu_tipologia_operatori_tooltip: 'Anagrafiche - Tipologia Operatori',
            menu_clienti: 'Clienti',
            menu_clienti_tooltip: 'Anagrafiche - Clienti',
            menu_appuntamenti: 'Appuntamenti',
            menu_appuntamenti_tooltip: 'Appuntamenti',
            menu_dashboard: 'Dashboard',
            menu_strutture: 'Strutture',
            menu_strutture_tooltip: 'Anagrafiche - Strutture',
            menu_impostazioni: 'Impostazioni',
            menu_occupazione: 'Occupazione',
            menu_priorita_commesse: 'Priorità commesse',
            menu_priorita_commesse_tooltip: 'Anagrafiche - Priorità commesse',
            menu_prodotti: 'Prodotti',
            menu_prodotti_tooltip: 'Anagrafiche - Prodotti',
            menu_rapportini: 'Rapportini',
            menu_rapportini_nuovo: 'Crea nuovo',
            menu_rapportini_nuovo_tooltip: 'Rapportini - Crea nuovo',
            menu_rapportini_nuovo_rapportino: 'Nuovo rapportino',
            menu_rapportini_resoconto: 'Resoconto',
            menu_rapportini_resoconto_tooltip: 'Rapportini - Resoconto',
            menu_macro_gruppi: 'Macro Gruppi',
            menu_macro_gruppi_tooltip: 'Anagrafiche - Macro Gruppi',
            menu_pazienti: 'Pazienti',
            menu_pazienti_tooltip: 'Anagrafiche - Pazienti',
            menu_sconti: 'Sconti',
            menu_sconti_tooltip: 'Anagrafiche - Sconti',
            menu_tag_commesse: 'Tag commesse',
            menu_tag_commesse_tooltip: 'Anagrafiche - Tag commesse',
            menu_utilita_calendario_eventi: 'Calendario eventi',
            menu_utilita_calendario_eventi_tooltip: 'Utilità - Calendario eventi',
            menu_utilita: 'Utilità',
            menu_utilita_archivio: 'Archivio',
            menu_utilita_archivio_tooltip: 'Utilità - Archivio',
            menu_utilita_chat: 'Chat',
            menu_utilita_chat_tooltip: 'Utilità - Chat',
            menu_utilita_log: 'Log',
            menu_utilita_log_tooltip: 'Utilità - Log',
            messaggio_conferma_eliminazione_selezionati: 'Dati eliminati con successo!',
            messaggio_conferma_ripristino_selezionati: 'Dati ripristinati con successo!',
            messaggio_duplicazione: 'Duplicare la commessa?',
            messaggio_eliminazione: 'Eliminare la commessa?',
            messaggio_eliminazione_selezionati: 'Sicuro di voler eliminare i dati selezionati?',
            messaggio_ripristina_selezionati: 'Sicuro di voler ripristinare i dati selezionati?',
            abitudini_vita: 'Abitudini di vita',
            messaggio_eliminato: 'Messaggio eliminato',
            dieta_libera_varia: 'Dieta libera e varia',
            dieta_controllata: 'Controllata per',
            digestione: 'Digestione regolare',
            medico_curante: 'Operatore curante',
            storia_malattie_paziente: 'Storia delle malattie del paziente',
            malattie_cuore: 'Malattie del cuore',
            malattie_cuore_descrizione: 'Descrizione malattie del cuore',
            pressione: 'Pressione',
            allergie: 'Allergie',
            quali_allergie: 'Quali allergie?',
            diabete: 'Diabete',
            tipologia_diabete: 'Tipologia diabete',
            epatite_virale: 'Epatite virale',
            tipologia_epatite: 'Tipologia epatite',
            malattie_fegato: 'Malattie del fegato',
            malattie_fegato_descrizione: 'Descrizione malattie del fegato',
            malattie_renali: 'Malattie renali',
            malattie_renali_descrizione: 'Descrizione malattie renali',
            malattie_tiroide: 'Malattie della tiroide',
            malattie_tiroide_descrizione: 'Descrizione malattie della tiroide',
            malattie_stomaco_tubo_digerente: 'Malattie dello stomaco o del tubo digerente',
            malattie_stomaco_tubo_digerente_descrizione:
                'Descrizione malattie dello stomaco o del tubo digerente',
            malattie_polmonari: 'Malattie polmonari',
            malattie_polmonari_descrizione: 'Descrizione malattie polmonari',
            malattie_veneree: 'Malattie veneree',
            malattie_veneree_descrizione: 'Descrizione malattie veneree',
            malattie_nervose_depressive: 'Malattie nervose e depressive',
            malattie_nervose_depressive_descrizione: 'Descrizione malattie nervose e depressive',
            malattie_oculari: 'Malattie oculari',
            malattie_oculari_descrizione: 'Descrizione malattie oculari',
            malattie_sangue_emorragie: 'Malattie del sangue ed emorragie',
            malattie_sangue_emorragie_descrizione: 'Descrizione malattie del sangue ed emorragie',
            malattie_non_elencate: 'Malattie non elencate',
            alitosi: 'Alitosi',
            conseguenze_particolari:
                "Conseguenze particolari in seguito all'assunzione di anestetici, antibiotici, analgesici o altri farmaci ?",
            esami_radiografici: 'Esami radiografici',
            esami_ematici: 'Esami ematici',
            esami_radiografici_descrizione: 'Descrizione esami radiografici',
            esami_ematici_descrizione: 'Descrizione esami ematici',
            malattie_gravi_interventi_chirurgici: 'Malattie gravi e/o interventi chirurgici',
            malattie_gravi_interventi_chirurgici_descrizione:
                'Descrizione malattie gravi e/o interventi chirurgici',
            menu_tipologie_visite: 'Tipologie visite',
            menu_tipologie_visite_tooltip: 'Anagrafiche - Tipologie visite',
            alvo: 'Alvo regolare',
            per_uomini: 'Per gli uomini',
            sonno: 'Sonno regolare',
            seleziona_elementi_da_esportare: 'Seleziona gli elementi da esportare',
            pdf_generato_correttamente: 'PDF generato correttamente',
            fumo: 'Fumo',
            fame_nervosa_desc: 'Soffri di fame nervosa?',
            stitichezza_desc: 'Soffri di stitichezza?',
            stitichezza: 'Stitichezza',
            fame_nervosa: 'Fame nervosa',
            tipo_acqua: 'Tipo di acqua',
            litri_giorno: 'Litri di acqua al giorno',
            seleziona_alimenti_preferiti: 'Seleziona alimenti preferiti (possibili più scelte)',
            quanto_fumo: 'Quantità giornaliera',
            tempo_fumo: 'Da quanto tempo?',
            numero_caffe: 'Numero di caffè giornalieri',
            caffe: 'Caffè',
            alcol: 'Alcolici',
            quali_alcol: 'Quali alcolici?',
            farmaci: 'Assume farmaci e/o droghe?',
            quali_farmaci: 'Quali farmaci e/o droghe?',
            tempo_farmaci: 'Da quanto tempo?',
            perche_farmaci: 'Perché?',
            antitetanica: 'Antitetanica',
            ultimo_antitetanica: 'Data ultima somministrazione',
            professione: 'Professione',
            per_donne: 'Per le donne',
            menarca_anni: 'Menarca',
            menarca_anni_testo: 'Anni',
            ultimo_ciclo: 'Ultimo ciclo',
            ciclo_regolare: 'Ciclo regolare',
            gravidanze: 'Gravidanze',
            numero_gravidanze: 'Numero di gravidanze',
            modifica: 'Modifica',
            mostra_dettagli: 'Mostra dettagli',
            mostra_ore: 'Visualizza il monte ore',
            nessuna_chat_selezionata: 'Nessuna chat selezionata',
            nessun_dato: 'Nessun dato presente',
            seleziona_anamnesi: 'Seleziona anamnesi',
            chiudi_anamnesi: 'Chiudi anamnesi',
            seleziona_icd9: 'Seleziona ICD9',
            ICD9: 'ICD9',
            anamnesi_salvata: 'Anamnesi salvata con successo!',
            data_evento: 'Data evento',
            appunti: 'Appunti',
            familiare: 'Familiare',
            seleziona_familiare: 'Seleziona familiare',
            diagnosi: 'Diagnosi',
            appunti: 'Appunti',
            annotazioni: 'Annotazioni',
            nessuna_email_cliente: 'Nessuna email presente per il cliente selezionato',
            nessun_cliente_selezionato: 'Nessun cliente selezionato',
            nessun_dato_archiviato: 'Non è presente alcun dato contrassegnato come archiviato',
            nominativo: 'Nominativo',
            nominativo_cliente: 'Nominativo cliente',
            nominativo_dipendente: 'Nominativo dipendente cliente',
            nome: 'Nome',
            sesso: 'Sesso',
            citta: 'Città',
            codice_fiscale: 'Codice Fiscale',
            cap: 'CAP',
            indirizzo: 'Indirizzo',
            indirizzo: 'Indirizzo',
            provincia: 'Provincia',
            non_programmato: 'Non programmato',
            note: 'Note',
            note_amministrative: 'Note amministrative',
            note_intervento: 'Note intervento',
            numero: 'Numero',
            numero_documento: 'Numero documento',
            oggi: 'Oggi',
            compila_tutti_i_campi_obbligatori: 'Compila tutti i campi obbligatori',
            occupazione: 'Occupazione',
            ore_effettive: 'Ore effettive',
            ore_lavorate: 'Ore lavorate',
            ore_lavorate_breve: 'ore lav.',
            ore_lavorate_breve_header: 'Ore lav.',
            ore_lavorate_effettive: 'Ore lavorate effettive',
            ore_lavorate_effettive_breve_header: 'Ore eff.',
            ore_viaggio: 'Ore viaggio',
            modifica_referto: 'Modifica referto',
            oppure: 'oppure',
            parametri: 'Parametri',
            genera_password: 'Genera password',
            pdf_generato_con_successo: 'PDF generato con successo',
            errore_generazione_pdf: 'Errore durante la generazione del PDF',
            referto_aggiornato_con_successo: 'Referto aggiornato con successo',
            errore_aggiornamento_referto: "Errore durante l'aggiornamento del referto",
            aggiorna_referto: 'Aggiorna referto',
            cambia_password: 'Cambia password',
            password: 'Password',
            password_aggiornata: 'Password aggiornata con successo!',
            password_cambiata: 'Password cambiata con successo!',
            password_gia_usata:
                "La password è già stata utilizzata in precedenza! Inserirne un'altra per continuare.",
            percentuale_completamento: 'Progresso',
            pianificazione: 'Pianificazione',
            privacy_policy: `<h1>INFORMATION FOR DATA PROCESSING</h1>
          
                <p>This page describes the methods of managing the site in relation to the processing of personal data of users who consult it, as well as the methods and purposes of processing personal data.</p>
          
                <p>This is information also provided pursuant to art. 13-14 EU Regulation 2016/679 to those who interact with the web services accessible electronically from the address.</p>
          
                <p>The information is provided only for the site in question and not for other websites that may be consulted through our links, for which it is in no way responsible.</p>
          
                <p>
          
                  In the capacity of Data Controller of your personal data, pursuant to and for the purposes of EU Regulation 2016/679 - GDPR, we hereby inform you that the aforementioned legislation provides for the protection of data subjects with respect to
          
                  processing of personal data and that such processing will be based on the principles of correctness, lawfulness, transparency and protection of your privacy and your rights.
          
                </p>
          
                <p>Your personal data will be processed in accordance with the legislative provisions of the above-mentioned regulation and the confidentiality obligations provided for therein.</p>
          
                <h2>TYPES OF DATA PROCESSED</h2>
          
                <h3>Navigation Data</h3>
          
                <p>
          
                  The computer systems and software procedures used to operate this website acquire, during their normal operation, some personal data whose transmission is implicit in the use of communication protocols.
          
                  Internet communication. This information is not collected to be associated with identified interested parties, but by its very nature could, through processing and association with data held by third parties,
          
                  allow to
          
                      allow users to be identified. This category of data includes IP addresses or domain names of computers used by users who connect to the site, URI (Uniform Resource Identifier) ​​addresses,
          
                      Identifier) ​​of the requested resources, the time of the request, the method used to submit the request to the server, the size of the file obtained in response, the numeric code indicating the status of the response given by the
          
                      server (successful, error, etc.) and other parameters relating to the operating system and the user's IT environment. These data are used for the sole purpose of obtaining anonymous statistical information on the use of the site and for
          
                      check its correct functioning and are deleted immediately after processing. The data could be used to ascertain responsibility in the event of hypothetical computer crimes against the site.
          
                    </p>
          
                    <h3>Data provided voluntarily by the user</h3>
          
                    <p>
          
                      The optional, explicit and voluntary sending of electronic mail to the addresses indicated on this site, as well as the completion of the forms for sending specific requests, entail the subsequent acquisition of the address of the
          
                      sender, necessary to respond to requests, as well as any other personal data included in the message or form.
          
                      <br />Specific summary information is reported or displayed on the site pages set up for particular services on request.
          
                    </p>
          
                    <h2>CONSEQUENCES OF REFUSING TO PROVIDE DATA</h2>
          
                    <p>
          
                      Apart from what is specified for navigation data, the user is free to provide personal data reported in the request forms, for subscription to mailing lists or in any case indicated in contacts to request the sending of material.
          
                      informational, technical or commercial or other communications. Failure to provide them may make it impossible to obtain what is requested.
          
                    </p>
          
                    <h2>METHODS OF TREATMENT</h2>
          
                    <p>
          
                      The data are processed mainly with electronic and computer tools and stored both on computer media and on paper media and on any other type of suitable media, in compliance with the methods set out in the articles.
          
                      6, 32 of the GDPR and by adopting the appropriate security measures provided for, to prevent data loss, illicit or incorrect use and unauthorized access.
          
                    </p>
          
                    <p>
          
                      We inform you that, in order to provide a complete service, our portal may contain links to other websites, not managed by us. We are not responsible for errors, contents, cookies, publications of illicit moral content,
          
                      advertising, banners or files that do not comply with current legislation and compliance with the Privacy legislation by sites managed by us to which reference is made. In order to improve the service offered, an immediate
          
                      reporting malfunctions, abuses or suggestions to the email address. Your data will be processed only by personnel expressly authorized by the Owner.
          
                    </p>
          
                    <h2>PURPOSE OF THE TREATMENT</h2>
          
                    <p>
          
                      The data processing will be carried out for:
          
                      <br />- provide the possibility of accessing the public and/or reserved sections of the site; <br />- execute the activation and maintenance of any services subscribed to online; <br />- carry out the obligations set out in
          
                      laws or regulations; <br />- the protection of the Owner in court; <br />- send commercial or promotional information material <br />- allow constant monitoring of the effectiveness of the proposed service.
          
                    </p>
          
                    <h2>SUBJECTS TO WHOM PERSONAL DATA MAY BE COMMUNICATED</h2>
          
                    <p>
          
                      The personal data relating to the processing in question may also be communicated to subjects who are recognised as having the right to access your personal data by law or secondary and/or community regulations.
          
                      Furthermore, some data may be communicated and disseminated to the internet operators used to manage their domains. The dissemination of the collected data is not foreseen.
          
                    </p>
          
                    <h2>DATA RETENTION PERIOD</h2>
          
                    <p>
          
                      We inform you that, in compliance with the principles of lawfulness, purpose limitation and data minimization, pursuant to art. 5 of the GDPR, the retention period of your personal data is 15 years. Upon expiry of the
          
                      After the aforementioned retention period, the personal data will be automatically deleted.
          
                    </p>
          
                    <h2>RIGHTS OF INTERESTED PARTIES</h2>
          
                    <p>EU Regulation 2016/679: Art. 15, 16, 17, 18, 19, 20, 21, 22 - Rights of the interested party</p>
          
                    <p>1. The interested party has the right to obtain confirmation of the existence or otherwise of personal data concerning him, even if not yet registered, and their communication in an intelligible form.</p>
          
                    <p>
          
                      2. The interested party has the right to obtain the indication:
          
                      <br />a. the origin of the personal data; <br />b. the purposes and methods of processing; <br />c. the logic applied in case of processing carried out with the aid of electronic instruments; <br />d. the details
          
                      identification of the owner, the managers and the designated representative pursuant to Article 5, paragraph 2; <br />e. the subjects or categories of subjects to whom the personal data may be communicated or who may
          
                      become aware of it as a designated representative in the territory of the State, as managers or agents.
          
                    </p>
          
                    <p>
          
                      3. The interested party has the right to obtain:
          
                      <br />a. the updating, rectification or, when interested, the integration of data; <br />b. the cancellation, transformation into anonymous form or blocking of data processed in violation of the law, including those
          
                      which does not need to be retained in relation to the purposes for which the data were collected or subsequently processed; <br />c. certification that the operations referred to in letters a) and b) have been brought to the attention of,
          
                      also with regard to their content, of those to whom the data have been communicated or disseminated, except in the case in which such fulfillment proves impossible or involves the use of means <br />d. manifestly
          
                      disproportionate to the right protected; <br />e. data portability.
          
                    </p>
          
                    <p>
          
                      4. The interested party has the right to object, in whole or in part:
          
                      <br />a. for legitimate reasons to the processing of personal data concerning him/her, even if pertinent to the purpose of the collection; <br />b. to the processing of personal data concerning him/her for the purpose of sending advertising material or
          
                      for direct sales or for carrying out market research or commercial communication
          
                    </p>
          
                    <p>
          
                      The user has the right to obtain from the owner the cancellation (right to be forgotten), limitation, updating, rectification, portability, opposition to the processing of personal data concerning him, as well as in
          
                      general can exercise all the rights provided for by art. 15, 16, 17, 18, 19, 20, 21, 22 of the GDPR.
          
                    </p>
          
                    <p>To exercise the rights listed above, the interested party must send a written request via email.</p>
          
                    <p></p>
          
                    <h2>COOKIES</h2>
          
                    <p>
          
                      Cookies are text files that are stored on the hard disk of a computer or other device by the online service provider for visitors to the website. Cookies can collect information about the
          
                      visitors' habits regarding the use of the aforementioned Internet site, recording the activities of their computer or other device regarding the aforementioned site, for example when it comes to making purchases.
          
                    </p>
          
                    <h3>COOKIES can be:</h3>
          
                    <h3>First-party cookies (also called first-party cookies)</h3>
          
                    <p>First-party cookies are cookies that are stored directly on your computer or other device. They may include cookies such as session cookies and persistent cookies (described below).</p>
          
                    <p>First-party cookies can be used to track the movements of the visitor's computer or other device when consulting the site, for example for analysis purposes.</p>
          
                    <h3>Cookie from the other side</h3>
          
                    <p>No third-party cookies are stored</p>
          
                    session cookie
          
                    <p>
          
                      The duration that elapses between the moment you open your Internet browser and the moment you close it is called a browsing session. Session cookies are cookies stored on your computer or other device.
          
                      visitor during a browsing session, but which expire and are normally deleted at the end of a browsing session.
          
                    </p>
          
                    <h3>Cookie persistenti</h3>
          
                    <p>
          
                      Persistent cookies are cookies stored on the visitor's computer or other device during a browsing session, but which remain on the computer or other device after the end of the browsing session.
          
                      (e.g. password registration). Persistent cookies allow sites to recognize the visitor's computer or other device when it is used to access one of our sites again, after the end of a session.
          
                      navigation and at the beginning of a new browsing session, essentially to help the visitor quickly reconnect to our site.
          
                    </p>
          
                    <p>
          
                      This site, for strictly technical reasons, uses the following types of cookies:
          
                      <br />- technical and session cookies, for example to avoid - where applicable - the user having to enter the password several times to access reserved sections of the site, or to store the preferred browsing language, or
          
                      to store some technical characteristics of the browser used for navigation (including the acceptance of cookies).
          
                    </p>
          
                    <p>It is possible to disable the use of cookies, but choosing such an option is likely to cause the site to malfunction, more or less evident depending on the section of the site you intend to visit.</p>
          
                    <p>To disable cookies, depending on the browser used, we can suggest some guides (valid at the time this document was written).</p>
          
                    Chrome
          
                    <p>1. Run Chrome Browser</p>
          
                    <p>2. Click the menu on the browser toolbar next to the URL entry box for navigation</p>
          
                    <p>3. Select Settings</p>
          
                    <p>4. Click Show Advanced Settings</p>
          
                    <p>5. In the “Privacy” section, click on the “Content settings“ button.</p>
          
                    <p>6. In the “Cookies” section you can change the following cookie settings:</p>
          
                    <ul>
          
                      <li>Allow local data saving</li>
          
                      <li>Modify local data only until the browser is closed</li>
          
                      <li>Block sites from setting cookies</li>
          
                      <li>Block third-party cookies and site data</li>
          
                      <li>Handle exceptions for some websites</li>
          
                      <li>Deleting one or all cookies</li>
          
                    </ul>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://support.google.com/accounts/answer/61416?hl=it" target="_blank">pagina dedicata</a>.
          
                    </p>
          
                    Mozilla Firefox
          
                    <p>1. Run Mozilla Firefox Browser</p>
          
                    <p>2. Click the menu on the browser toolbar next to the URL entry box for navigation</p>
          
                    <p>3. Select Options</p>
          
                    <p>4. Select the Privacy panel</p>
          
                    <p>5. Click Show Advanced Settings</p>
          
                    <p>6. In the “Privacy” section, click on the “Content settings“ button.</p>
          
                    <p>7. In the “Tracking” section you can change the following cookie settings:</p>
          
                    <ul>
          
                      <li>Ask sites not to track you</li>
          
                      <li>Tell sites you're willing to be tracked</li>
          
                      <li>Do not communicate any preference regarding the tracking of personal data</li>
          
                    </ul>
          
                    <p>8. From the “History” section you can:</p>
          
                    <ul>
          
                      <li>
          
                        By enabling “Use custom settings” you select to accept third-party cookies (always, from the most visited sites or never) and to store them for a specific period (until they expire, at
          
                        closing Firefox or asking every time)
          
                      </li>
          
                      <li>Remove individual stored cookies</li>
          
                    </ul>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank">dedicated page</a>.
          
                    </p>
          
                    <h3>Internet Explorer</h3>
          
                    <p>1. Run Internet Explorer Browser</p>
          
                    <p>2. Click the Tools button and choose Internet Options</p>
          
                    <p>3. Click on the Privacy tab and in the Settings section change the slider according to the desired action for cookies:</p>
          
                    <ul>
          
                      <li>Block all cookies</li>
          
                      <li>Allow all cookies</li>
          
                      <li>
          
                        Selecting the sites from which to obtain cookies: move the cursor to an intermediate position so as not to block or allow all cookies, then press on Sites, in the Website Address box enter a website and
          
                        then press Block or Allow
          
                      </li>
          
                    </ul>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://support.microsoft.com/it-it/products/windows?os=windows-10" target="_blank">pagina dedicata</a>.
          
                    </p>
          
                    Safari 6/7
          
                    <p>1. Run Safari Browser</p>
          
                    <p>2. Click on Safari, select Preferences and press Privacy</p>
          
                    <p>3. In the Block Cookies section, specify how Safari should accept cookies from websites.</p>
          
                    <p>4. To see which sites have stored cookies click on Details</p>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://support.apple.com/kb/PH17191?locale=en_US&amp;viewlocale=it_IT" target="_blank">pagina dedicata</a>.
          
                    </p>
          
                    <h3>Safari iOS (mobile devices)</h3>
          
                    <p>1. Run iOS Safari Browser</p>
          
                    <p>2. Tap Settings and then Safari</p>
          
                    <p>3. Tap on Block Cookies and choose between the various options: “Never”, “Third-party and advertisers” or “Always”</p>
          
                    <p>4. To delete all cookies stored by Safari, tap Settings, then Safari, and then Clear Cookies and Data</p>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://support.apple.com/it-it/HT201265" target="_blank">pagina dedicata</a>.
          
                    </p>
          
                    Opera
          
                    <p>1. Run Opera Browser</p>
          
                    <p>2. Click on Preferences then on Advanced and finally on Cookies</p>
          
                    <p>3. Select one of the following options:</p>
          
                    <ul>
          
                      <li>Accept all cookies</li>
          
                      <li>Accept cookies only from the site you are visiting: third-party cookies and those sent from a domain other than the one you are visiting will be rejected</li>
          
                      <li>Never accept cookies: all cookies will never be saved</li>
          
                    </ul>
          
                    <p>
          
                      For more information visit the
          
                      <a href="https://www.opera.com/help/tutorials/security/privacy/" target="_blank">pagina dedicata</a>.
          
                    </p>
          
                    <p>
          
                      If the program you use to navigate websites is not among those mentioned above, we suggest you use an online search engine (google, yahoo, bing...) to understand how to disable cookies in
          
                      that specific browser.
          
                    </p>`,
            prodotti: 'Prodotti',
            prodotti_relativi_ordine: "Prodotti relativi all'ordine",
            prodotti_utilizzati: 'Prodotti utilizzati',
            profilo_aggiornato: 'Profilo aggiornato con successo!',
            profilo_personale: 'Profilo personale',
            rapportini: 'Rapportini',
            referti: 'Referti',
            oggetto: 'Oggetto',
            menu_referti_nuovo_tooltip: 'Crea un nuovo referto',
            menu_referti_nuovo: 'Nuovo Referto',
            menu_referti_aggiorna: 'Aggiorna Referto',
            menu_referti_aggiorna_tooltip: 'Aggiorna un referto esistente',
            menu_referti_visualizza: 'Visualizza Referti',
            menu_referti_resoconto: 'Resoconto Referti',
            oggetto_referto: 'Oggetto Referto',
            menu_referti: 'Referti',
            nuovo_referto_medico: 'Nuovo Referto Operatore',
            data_referto: 'Data Referto',
            esame_obiettivo: 'Esame Obiettivo',
            terapia_prescritta: 'Terapia Prescritta',
            note_aggiuntive: 'Note Aggiuntive',
            firma: 'Firma',
            firma_referto: 'Firma referto',
            salva_bozza: 'Salva Bozza',
            bozza: 'Bozza',
            consegnato: 'Consegnato',
            salva_referto: 'Salva Referto',
            nuovo_referto: 'Nuovo Referto',
            menu_referti_resoconto_tooltip: 'Visualizza il resoconto dei referti',
            rapportino_inviato: 'Rapportino inviato con successo!',
            rapportino_ricevuto: 'Rapportino ricevuto',
            relazione_intervento: 'Relazione intervento',
            resoconto: 'Resoconto',
            riprendi_timer: 'Riprendi timer',
            ripristina: 'Ripristina',
            risorsa: 'Collaboratore',
            risorse: 'Collaboratori',
            salva: 'Salva',
            scorciatoia_ctrl_b: 'Apri/chiudi menu: CTRL + B',
            seleziona: 'Seleziona',
            seleziona_foto: 'Seleziona foto',
            settimana: 'Settimana',
            settimana_attuale: 'Settimana attuale',
            standard: 'Standard',
            stato: 'Stato',
            successo: 'Successo',
            su: 'su',
            su_cosa_hai_lavorato: 'Su cosa hai lavorato?',
            telefono: 'Telefono',
            tempo_rimanente: 'Tempo rimanente',
            termina_modifica: 'Termina prima la modifica in corso!',
            testo_copiato: 'Testo copiato negli appunti',
            titolo_cambio_password: 'Cambio password',
            torna_indietro: 'Torna indietro',
            totale_ore: 'Totale ore',
            trasferta: 'Trasferta',
            tutti_i_campi_devono_essere_compilati:
                'Tutti i campi obbligatori devono essere compilati',
            url: 'URL',
            username: 'Username',
            utenti: 'Utenti',
            verifica_campi: 'Verifica i campi inseriti',
            visualizzi_da: 'Visualizzi da',
            zero_ore_lavorate_breve: '0 ore lav.',

            //NUOVE TRADUZIONI (AGGIUNTE CON newmed)
            allergie_intolleranze: 'Allergie e intolleranze',
            insorgenza_malattia: 'Insorgenza malattia',
            modalita_insorgenza: 'Modalità insorgenza',
            sintomatologia: 'Sintomatologia',
            fattori_scatenanti: 'Fattori scatenanti',
            fattori_allevianti: 'Fattori allevianti',
            farmaci_assunti: 'Farmaci assunti',
            terapie_precedenti: 'Terapie precedenti',
            disturbi_associati: 'Disturbi associati',

            // Traduzioni per importazione Excel pazienti
            paziente_gia_presente: 'Paziente già presente',
            paziente_aggiornato: 'Paziente aggiornato',
            paziente_aggiunto: 'Paziente aggiunto',
            dati_importati_con_successo: 'Dati importati con successo',
            errore_importazione: "Errore durante l'importazione",
            formato_file_non_supportato: 'Formato file non supportato',
            seleziona_file_excel: 'Seleziona file Excel',
            anteprima_dati: 'Anteprima dati',
            conferma_importazione: 'Conferma importazione',
            pazienti_da_importare: 'Pazienti da importare',
            pazienti_importati: 'Pazienti importati',
            pazienti_aggiornati: 'Pazienti aggiornati',
            processing_import: 'Elaborazione importazione in corso...',
            file_non_valido: 'File non valido',
            dati_non_validi: 'Dati non validi nel file',
            conferma_creazione_commessa_con_padre:
                'Sei sicuro di voler creare una commessa figlia? Se la commessa padre ha una pianificazione, questa verrà eliminata.',
            utenti_in_carico: 'Utenti in carico',
            lascia_incarico: 'Lascia incarico',
            conferma_lascia_incarico: "Sei sicuro di voler lasciare l'incarico di questa commessa?",
            conferma_presa_in_carico: 'Sei sicuro di voler prendere in carico questa commessa?',
            commessa_presa_in_carico: 'Commessa presa correttamente in carico!',
            no_utente_in_carico: 'Nessun utente ha ancora preso in carico questa commessa',
            prendi_in_carico: 'Prendi in carico',
            conferma_svuotamento_tabella: 'Sei sicuro di voler svuotare la tabella?',
            svuotamento_tabella: 'Svuotamento tabella',
            svuota_tabella: 'Svuota tabella',
            codice_otp: 'Codice OTP',
            codice_otp_testo: 'Inserisci il codice OTP generato dalla tua app di autenticazione.',
            troppi_errori_verifica_codice:
                'Troppi errori nella verifica del codice, stai per essere riportato alla pagina del login.',
            codice_inserito_errato: 'Il codice inserito non è corretto, riprova.',
            prezzo_totale: 'Prezzo totale',
            tentativi_rimanenti: 'Tentativi rimanenti: ',
            periodo: 'Periodo',
            mostra_utenti_selezionati: 'Mostra utenti',
            nascondi_utenti_selezionati: 'Nascondi utenti',
            visualizza: 'Visualizza',
            crea_copia: 'Crea copia',
            ricorda_calcola_prezzi: "Ricorda di calcolare i prezzi se non l'hai ancora fatto!",
            modifica_copia: 'Modifica copia',
            totale: 'Totale',
            genera_pdf: 'Genera PDF',
            desideri_generare_pdf: 'Desideri generare il PDF',
            creato_con_successo: 'Creato con successo',
            nessuna_commessa: 'Nessuna commessa presente',
            collaboratori: 'Collaboratori',
            copia_rapportino: 'Copia rapportino',
            denominazione_commessa: 'Denominazione commessa',
            chiudi_righe: 'Chiudi righe',
            colonna_bloccata: 'Colonna bloccata, non è possibile rimuoverla dalla visualizzazione',
            firma_cliente_mancante: 'Firma del cliente mancante',
            firma_tecnico_mancante: 'Firma del tecnico mancante',
            configurazione_tabella_salvata: 'Configurazione tabella salvata',
            errore_salvataggio_configurazione: 'Errore durante il salvataggio della configurazione',
            colonne_da_visualizzare: 'Colonne da visualizzare',
            sconti: 'Sconti',
            mostra_sconti: 'Mostra sconti',
            installa_pwa: 'Installa app',
            // --- PWA INSTALL DIALOG KEYS (IT) ---
            pwa_install_title: "Installa l'Applicazione",
            pwa_intro:
                "Puoi installare questa applicazione come PWA per un'esperienza più veloce, accesso rapido e utilizzo a schermo intero.",
            pwa_section_desktop: 'Desktop (Chrome / Edge / Brave)',
            pwa_desktop_step_1:
                "Apri il menu del browser oppure clicca sull'icona di installazione vicino alla barra degli indirizzi.",
            pwa_desktop_step_2: 'Seleziona "Installa app" oppure "Installa NewMed".',
            pwa_desktop_step_3: 'Conferma nella finestra di dialogo.',
            pwa_section_android_chrome: 'Android (Chrome)',
            pwa_android_step_1: 'Tocca il menu ⋮ in alto a destra.',
            pwa_android_step_2: 'Seleziona "Aggiungi a schermata Home".',
            pwa_android_step_3: 'Conferma il nome e premi Aggiungi.',
            pwa_section_ios_safari: 'iOS (Safari)',
            pwa_ios_step_1: "Tocca il pulsante Condividi (quadrato con freccia verso l'alto).",
            pwa_ios_step_2: 'Scorri e seleziona "Aggiungi alla schermata Home".',
            pwa_ios_step_3: "Premi Aggiungi nell'angolo in alto.",
            pwa_section_ios_chrome: 'iOS (Chrome / altri browser)',
            pwa_ios_chrome_note:
                "I browser diversi da Safari utilizzano comunque Safari per completare l'aggiunta alla schermata Home.",
            pwa_ios_chrome_step_1: 'Apri il menu ⋮/… e scegli "Condividi".',
            pwa_ios_chrome_step_2:
                'Nel foglio di condivisione scegli "Aggiungi alla schermata Home" in Safari.',
            pwa_install_now: 'Prova installazione rapida',
            pwa_do_not_show_again: 'Non mostrare più questo messaggio',
            pwa_security_note:
                "Nota: l'installazione è sicura e non richiede permessi aggiuntivi. Puoi rimuovere la PWA in qualsiasi momento.",
            // --- FINE PWA INSTALL DIALOG KEYS (IT) ---
            ancora_destra: 'Ancora a destra',
            dialog_recuperato: 'Finestra recuperata',
            passato_a_dataview: "Passato alla visualizzazione tramite 'Griglia'",
            passato_a_tabs: "Passato alla visualizzazione tramite 'Tabs'",
            ultima_volta_sincronizzati: "Dati sincronizzati l'ultima volta il",
            aggiungi_elemento_creazione: 'Aggiungi elemento in creazione',
            centra_dialog: 'Centra finestra',
            minimizza: 'Minimizza finestra',
            massimizza: 'Massimizza finestra',
            minimizza_mobile: 'Minimizza',
            massimizza_mobile: 'Massimizza',
            mostra_eventi_click: 'Mostra eventi al click',
            mostra_eventi_hover: 'Mostra eventi al hover',
            riapri_dialog: 'Riapri finestra',
            setup_salvato: 'Setup della finestra salvato',
            setup_rimosso: 'Setup della finestra rimosso',
            salva_setup_localmente: 'Salva setup della finestra localmente',
            elimina_setup_localmente: 'Elimina setup della finestra localmente',
            ricarica: 'Ricarica',
            visualizza_tabs: "Passa alla visualizzazione tramite 'Tabs'",
            visualizza_dataview: "Passa alla visualizzazione tramite 'Griglia'",
            no_dato_trovato: 'Nessun dato trovato',
            disancora_elemento: 'Disancora elemento',
            sposta_a: 'Sposta a',
            destra: 'Destra',
            sinistra: 'Sinistra',
            eliminazione_dati: 'Eliminazione di dati',
            dato_ricaricato: 'Dato ricaricato con successo!',
            conferma_chiusura_dialog: 'Sei sicuro di voler chiudere la finestra?',
            conferma_azione: 'Conferma azione',
            categoria_risorsa: 'Categoria risorsa',
            duefa: 'App di autenticazione',
            password_temporanea: 'Password temporanea',
            nessun_elemento_aperto_dialog: 'Nessun elemento aperto in questa finestra',
            suggerimenti_dialog_vuota: `Per iniziare, puoi aprire un elemento esistente cliccando sul bottone \'Dettagli\' sulla destra della tabella, oppure crearne uno nuovo usando la Toolbar qui sopra.\nSe in precedenza hai salvato un setup, puoi recuperarlo sempre dalla Toolbar.`,
            setup_non_trovato: 'Setup non trovato',
            setup_ottenuto: 'Setup ottenuto con successo',
            get_setup: 'Ottieni il setup salvato',
            avviso: 'Avviso',
            tooltip_password_temporanea:
                "La password temporanea sarà disponibile per il login solo una volta: una volta effettuato il primo accesso, l'utente verrà obbligato a cambiarla!",
            creazione_gia_in_corso: 'Creazione già in corso!',
            chiudi_elemento: 'Chiudi elemento',
            archivia: 'elimina',
            seleziona_file: 'Seleziona file',
            importazione_dati: 'Importazione di dati',
            importazione_dati_riuscita: 'Importazione di dati riuscita!',
            importazione_dati_fallita: 'Importazione di dati fallita!',
            importazione_dati_errore: "Errore durante l'importazione dei dati!",
            importazione_in_corso: 'Importazione in corso...',
            elementi_importati: 'Elementi importati',
            ragione_sociale: 'Ragione sociale',
            sigla: 'Sigla',
            descma: 'Descma',
            cod_fornitore: 'Cod. fornitore',
            cod_prodotto: 'Cod. prodotto',
            prezzo_netto: 'Prezzo netto',
            prezzo_listino: 'Prezzo di listino',
            stato_prodotto: 'Stato prodotto',
            barcode: 'Barcode',
            unita_misura: 'Unità di misura',
            serie_vendita: 'Serie vendita',
            cod_numerico: 'Cod. numerico',
            qta_min_acquistabile: 'Qta. min. acquistabile',
            gruppo_1: 'Gruppo 1',
            gruppo_2: 'Gruppo 2',
            gruppo_3: 'Gruppo 3',
            moltipli_prezzo: 'Moltipl. prezzo',
            moltipli_prezzo_netto: 'Moltipl. prezzo netto',
            iva: 'Iva',
            preferiti: 'Preferiti',
            dettagli: 'Dettagli',
            cvs_headers_errore: 'Errore nel file inserito! Headers mancanti',
            desc_serie_vendita: 'Descrizione serie vendita',
            data_validita: 'Data validità',
            sconto1: 'Sconto 1',
            sconto2: 'Sconto 2',
            sconto3: 'Sconto 3',
            sconto4: 'Sconto 4',
            sconto5: 'Sconto 5',
            seleziona_righe_prima:
                'Per poter eliminare degli elementi, prima seleziona delle righe tramite la casella sulla sinistra della tabella!',
            data_non_valida: 'Data non valida',
            prezzo_ora: 'Prezzo ora',
            commessa_padre: 'Commessa padre',
            alta: 'Alta',
            media: 'Media',
            bassa: 'Bassa',
            priorita: 'Priorità',
            dal: 'Dal',
            al: 'Al',
            no_categoria: 'Nessuna categoria',
            note_per_risorse: 'Note per le risorse',
            descrizione_commessa: 'Descrizione commessa',
            commessa_principale: 'Commessa principale',
            utenti_creatori: 'Utenti creatori',
            unione_filtri: 'Unione filtri',
            applica_filtri: 'Applica filtri',
            filtri: 'Filtri',
            oppure: 'Oppure',
            e: 'E',
            amministratore: 'Amministratore',
            se_null_imposta_inizio:
                "Se lasciato vuoto, verrà automaticamente impostato come un'evento con durata solo un giorno (quello selezionato come inizio)",
            vai_a_profilo: 'Vai al profilo',
            commessa_da_pianificare: 'La commessa non è ancora stata pianificata.',
            commessa_gia_pianificata: 'La commessa è già stata pianificata.',
            pianifica: 'Pianifica',
            firma_cliente: 'Firma cliente',
            firma_tecnico: 'Firma tecnico',
            pulisci: 'Pulisci',
            totale_imponibile_iva_esclusa: 'Totale imponibile iva esclusa',
            prezzo_orario: 'Prezzo orario',
            nessun_prodotto_utilizzato: 'Nessun prodotto utilizzato',
            aggiungi_un_prodotto_per_cominciare: 'Aggiungi un prodotto per cominciare',
            nessun_risorsa_associata: 'Nessuna risorsa associata',
            aggiungi_una_risorsa_per_cominciare: 'Aggiungi una risorsa per cominciare',
            ditta_installatrice: 'Ditta installatrice',
            prezzo_calcolato: 'Prezzo calcolato',
            quantita: 'Quantità',
            calcola: 'Calcola',
            tipologia_lavoro_svolto: 'Tipologia lavoro svolto',
            mostra_prodotti_selezionati: 'Mostra prodotti',
            nascondi_prodotti_selezionati: 'Nascondi prodotti',
            mostra_risorse_selezionate: 'Mostra risorse',
            nascondi_risorse_selezionate: 'Nascondi risorse',
            sei_sicuro_di_voler_rimuovere_prodotto: 'Sei sicuro di voler rimuovere il prodotto',
            sei_sicuro_di_voler_rimuovere_risorsa: 'Sei sicuro di voler rimuovere la risorsa',
            si: 'Si',
            no: 'No',
            attenzione: 'Attenzione',
            numero_rapportini: 'Numero rapportini',
            mese: 'Mese',
            denominazione_cliente: 'Denominazione cliente',
            visualizza_firme: 'Visualizza firme',
            pdf_rapportino: 'PDF rapportino',
            visualizza_rapportino_pdf: 'Visualizza PDF rapportino',
            scarica_rapportino_pdf: 'Scarica PDF rapportino',
            elimina_rapportino_pdf: 'Elimina PDF rapportino',
            generazione_pdf: 'Generazione PDF in corso...',
            generazione_pdf_completata: 'Generazione PDF completata con successo!',
            programmata: 'Programmata',
            in_corso: 'In corso',
            completata: 'Completata',
            info_commesse_pianificazione: 'INFO COMMESSE',
            modifica_creazione: 'Creazione e Modifica',
            visualizza_commesse: 'Visualizzazione Commesse',
            step_commesse: 'Step delle Commesse',
            pianificazione_commesse: 'Pianificazione Commesse',
            descrizione_modifica_creazione:
                'Qui puoi creare nuove commesse e modificarle facilmente.',
            descrizione_visualizzazione:
                'Accedi alla lista delle commesse per una panoramica completa.',
            descrizione_step:
                ' Ogni commessa è suddivisa in vari step che possono essere monitorati.',
            conferma_pianifica: 'Vuoi pianificare la commessa appena creata?',
            descrizione_pianificazione:
                'La pianificazione di una commessa consiste nella organizzazione di tutte le attività necessarie per completarla in modo efficiente.',
            popup_modifica_creazione: `
              <p><strong>Premendo il tasto "+" in alto a destra si possono inserire nuove commesse con relativi dati:</strong></p>
              <ul>
                <li><strong>Nome:</strong> Identificativo univoco della commessa per facilitarne la gestione e il riconoscimento.</li>
                <br>
                <li><strong>Cliente:</strong> Nome del cliente per cui viene creata la commessa.</li>
                <br>
                <li><strong>Commessa padre:</strong> Opzione per creare gerarchie tra commesse, assegnando una commessa principale (utile per suddividere progetti più complessi).</li>
                <br>
                <li><strong>Priorità:</strong> Indica l'urgenza della commessa, scegliendo tra Alta, Media o Bassa per facilitare l'organizzazione delle attività.</li>
                <br>
                <li><strong>Descrizione:</strong> Testo libero in cui specificare dettagli e informazioni fondamentali sul contenuto della commessa.</li>
                <br>
                <li><strong>Note:</strong> Sezione per aggiungere annotazioni, commenti o eventuali informazioni aggiuntive utili alla gestione della commessa.</li>
              </ul>
              `,
            popup_visualizza_commesse: `
                <p><strong>Visualizzazione delle Commesse</strong></p>
                <p>Le commesse vengono organizzate e visualizzate con criteri chiari e strutturati per garantire una gestione efficace e intuitiva.
                La visualizzazione può avvenire in base a diversi parametri:</p>
                <ul>
                  <li>
                    <strong>Nome:</strong> Le commesse vengono identificate attraverso il loro nome univoco, consentendo una ricerca immediata e precisa.
                    Questo criterio è utile per chi gestisce numerose commesse e ha bisogno di riconoscerle facilmente.
                  </li>
                  <br>
                  <li>
                    <strong>Priorità:</strong> Ogni commessa è classificata in base al livello di urgenza, che può essere <strong>Alta</strong>, <strong>Media</strong> o <strong>Bassa</strong>.
                    Questo filtro permette di organizzare le attività in modo efficace, dando precedenza alle commesse più importanti o urgenti.
                  </li>
                  <br>
                  <li>
                    <strong>Data di Creazione:</strong> Le commesse vengono elencate in ordine cronologico, permettendo di identificare rapidamente le più recenti
                    oppure di consultare quelle meno recenti per eventuali revisioni o aggiornamenti. Questo metodo di visualizzazione è utile per tracciare
                    l’evoluzione delle attività nel tempo.
                  </li>
                </ul>
                `,
            popup_step_commesse: `
                <p><strong>Visualizzazione delle Gerarchie delle Commesse</strong></p>
                <p>Premendo il tasto "<strong>></strong>", sarà possibile espandere e visualizzare la struttura gerarchica delle commesse.</p>
                <ul>
                  <li><strong>Commesse principali:</strong> Verranno inizialmente mostrate in un elenco compatto per una visualizzazione più chiara.</li>
                  <br>
                  <li><strong>Commesse subordinate:</strong> Cliccando sul pulsante di espansione, si potranno vedere le commesse collegate a ciascuna commessa principale.</li>
                  <br>
                  <li><strong>Organizzazione intuitiva:</strong> Grazie a questa struttura, è possibile gestire progetti complessi suddividendo le attività in sezioni più chiare e facilmente navigabili.</li>
                </ul>
                `,
            popup_pianifazione_commesse: `
            <p><strong>Pianificazione della Commesse</strong></p>
            <p>La pianificazione di una commessa è essenziale per garantire un'organizzazione chiara e una gestione efficiente delle attività. Ogni commessa viene strutturata in base a diversi parametri fondamentali:</p>
            <ul>
              <li><strong>Commessa principale:</strong> Identificativo della commessa principale, utile per creare una gerarchia tra le attività e suddividere progetti più complessi.</li>
              <br>
              <li><strong>Data di inizio e fine:</strong> Ogni commessa è programmata con una data di inizio e una data di completamento, permettendo di stabilire scadenze e monitorare i progressi nel tempo.</li>
              <br>
              <li><strong>Collaboratori:</strong> La commessa può essere assegnata a uno o più collaboratori, facilitando il lavoro di squadra e la distribuzione dei compiti tra i vari membri del team.</li>
              <br>
              <li><strong>Stato della commessa:</strong> Ogni commessa può trovarsi in uno dei seguenti stati:</li>
              <ul>
                <li><strong>In corso:</strong> La commessa è attiva e le attività sono in fase di sviluppo.</li>
                <br>
                <li><strong>Completata:</strong> Tutte le attività sono state concluse con successo.</li>
                <br>
                <li><strong>Non completata:</strong> La commessa è stata interrotta o non è stata portata a termine secondo la pianificazione iniziale.</li>
                <br>
              </ul>
            </ul>
          <p>Grazie a questa struttura organizzativa, la pianificazione delle commesse diventa più chiara e permette un controllo preciso su ogni fase del lavoro.</p>
          `,
            mostra_commesse: 'Mostra',
            funzionamento_filtri: 'Funzionamento filtri',
            descrizione_filtri: `
           <h2>1. Filtro Collaboratori <i class="fal fa-solid fa-users"></i></h2>
            <p>Permette di selezionare uno o più utenti per visualizzare solo gli elementi (progetti, attività, risorse) a cui partecipano.</p>
            <p><strong>Logica Oppure:</strong> Mostra gli elementi con almeno uno dei collaboratori selezionati (es. Marco oppure Luca).</p>
            <p><strong>Logica E:</strong> Mostra solo gli elementi dove tutti i collaboratori selezionati sono presenti (es. Marco e Luca insieme).</p>

            <h2>2. Filtro Categorie <i class="fal fa-solid fa-list"></i></h2>
            <p>Filtra per tipologia di contenuto (es. Marketing, Formazione...). Supporta selezione singola o multipla.</p>
            <p><strong>Logica consigliata:</strong> Oppure. Esempio: selezionando “Marketing” e “Vendite” si vedono gli elementi che appartengono a una delle due.</p>

            <h2>3. Filtro Utenti Creatore <i class="fa-solid fa-user-tie"></i></h2>
            <p>Filtra in base a chi ha creato l’elemento (es. “mostra tutte le risorse create da Marco”).</p>

            <h2>Logica E vs Oppure <i class="fal fa-solid fa-gears"></i></h2>
            <ul>
              <li><strong>Collaboratori:</strong> E = tutti presenti / Oppure = almeno uno presente</li>
              <li><strong>Categorie:</strong> E = tutte / Oppure = una qualsiasi</li>
              <li><strong>Clienti:</strong> E = tutti  / Oppure = uno qualsiasi</li>
              <li><strong>Creatori:</strong> E = poco sensato / Oppure = uno qualsiasi</li>
            </ul>
            <p><strong>Nota:</strong> la logica Oppure è la più intuitiva e raccomandata nella maggior parte dei casi.</p>
`,
            // --- FINE CHIAVI MANCANTI ---
        },
        en: {
            appuntamenti: 'Appointments',
            accesso_negato: 'Access denied',
            no_permessi_spostamento_appuntamento:
                'You do not have permission to move this appointment',
            no_permessi_appuntamento: 'You do not have permission to edit this appointment',
            si: 'Yes',
            firma_medico: 'Doctor signature',
            consegnato: 'Delivered',
            diagnosi: 'Diagnosis',
            firmato: 'Signed',
            bozza: 'Draft',
            no: 'No',
            tutte_le_strutture: 'All structures',
            medico_selezionato: 'Doctor:',
            settimanale: 'Weekly',
            tutti_i_medici: 'All doctors',
            giornaliera: 'Daily',
            vista: 'View:',
            struttura_selezionata: 'Structure:',
            aggiungi_appuntamento: 'Add appointment',
            giornata_libera: 'Free day!',
            nessun_appuntamento_programmato_per: 'No appointment scheduled for',
            prossimi_appuntamenti: 'Upcoming appointments',
            prossimi: 'Next',
            verifica_campi: 'Check the fields highlighted',
            password_temporanea: 'Temporary password',
            conferma_azione: 'Confirm action',
            conferma_chiusura_dialog: 'Are you sure you want to close the window?',
            dato_ricaricato: 'Data reloaded successfully!',
            successo: 'Success',
            configurazione_tabella_salvata: 'Table configuration saved',
            errore_salvataggio_configurazione: 'Error saving configuration',
            mostra_sconti: 'Show discounts',
            sposta_a: 'Move to',
            destra: 'Right',
            sinistra: 'Left',
            ricarica: 'Reload',
            eliminazione_dati: 'Data deletion',
            ultima_volta_sincronizzati: 'Data last synchronized on',
            aggiungi_elemento_creazione: 'Add item in creation',
            visualizza_dataview: 'Switch to grid view',
            centra_dialog: 'Center dialog',
            minimizza: 'Minimize window',
            massimizza: 'Maximize window',
            minimizza_mobile: 'Minimize',
            salva_setup_localmente: 'Save window setup locally',
            elimina_setup_localmente: 'Delete window setup locally',
            telefono: 'Phone',
            cellulare: 'Mobile',
            fax: 'Fax',
            ancora_destra: 'Anchor right',
            username: 'Username',
            salva: 'Save',
            colonne_da_visualizzare: 'Columns to display',
            colonna_bloccata: 'Locked column, cannot be removed from view',
            visualizzi_da: 'View',
            visualizzi_data: 'You are viewing data from',
            scorciatoia_ctrl_b: 'Shortcut Ctrl+B',
            riapri_dialog: 'Reopen window',
            installa_pwa: 'Install app',
            // --- PWA INSTALL DIALOG KEYS (EN) ---
            pwa_install_title: 'Install the Application',
            pwa_intro:
                'You can install this application as a PWA for a faster, fullscreen experience and quick access.',
            pwa_section_desktop: 'Desktop (Chrome / Edge / Brave)',
            pwa_desktop_step_1:
                'Open the browser menu or click the install icon near the address bar.',
            pwa_desktop_step_2: 'Select "Install app" or "Install NewMed".',
            pwa_desktop_step_3: 'Confirm in the dialog.',
            pwa_section_android_chrome: 'Android (Chrome)',
            pwa_android_step_1: 'Tap the ⋮ menu (top right).',
            pwa_android_step_2: 'Select "Add to Home screen".',
            pwa_android_step_3: 'Confirm the name and tap Add.',
            pwa_section_ios_safari: 'iOS (Safari)',
            pwa_ios_step_1: 'Tap the Share button (square with upward arrow).',
            pwa_ios_step_2: 'Scroll and tap "Add to Home Screen".',
            pwa_ios_step_3: 'Tap Add in the upper corner.',
            pwa_section_ios_chrome: 'iOS (Chrome / other browsers)',
            pwa_ios_chrome_note:
                'Non-Safari browsers rely on Safari to complete adding to the Home Screen.',
            pwa_ios_chrome_step_1: 'Open the ⋮/… menu and choose "Share".',
            pwa_ios_chrome_step_2: 'In the share sheet choose "Add to Home Screen" (Safari).',
            pwa_install_now: 'Try quick install',
            pwa_do_not_show_again: 'Do not show this again',
            pwa_security_note:
                'Note: installation is safe and requires no extra permissions. You can remove the PWA anytime.',
            // --- END PWA INSTALL DIALOG KEYS (EN) ---
            vai_a_profilo: 'Go to profile',
            visualizzi_data: 'You are viewing data from',
            seleziona_medico_per_visualizzare_disponibilita: 'Select doctor to view availability',
            disponibilita_medici: 'Doctors availability',
            tipologia_transazione: 'Transaction Type',
            giftcard: 'Giftcard',
            firma_non_presente: 'Signature not present',
            menu_risorse: 'Specialists List',
            credito_attuale: 'Current Credit',
            aggiunta: 'Addition',
            sottrazione: 'Subtraction',
            credito_residuo_dopo_operazione: 'Remaining credit after operation',
            calcolo_automatico_del_nuovo_saldo: 'Automatic calculation of new balance',
            paese_nascita: 'Country of Birth',
            campo_obbligatorio: 'Required field',
            importo: 'Amount',
            conferma_inserimento_transazione: 'Confirm transaction entry',
            saldo_pre_transazione: 'Pre-transaction balance',
            saldo_post_transazione: 'Post-transaction balance',
            resoconto_transazioni: 'Transaction summary',
            aggiungi_transazione: 'Add transaction',
            registra_firma: 'Register signature',
            attendendo_firma_dispositivo: 'Waiting for device signature...',
            cambia_firma: 'Change signature',
            nessuna_transazione: 'No transactions',
            nessuna_transazione_giftcard_registrata: 'No giftcard transactions registered',
            inserimento_eseguito: 'Insertion completed successfully!',
            stampa: 'Print',
            tipo: 'Type',
            medici: 'Doctors',
            residenza: 'Residence',
            importa_excel: 'Import Excel',
            elenco_specialisti: 'Specialists List',
            menu_elenco_personale: 'Specialists List',
            menu_elenco_personale_tooltip: 'Registry - Specialists List',
            salva_appuntamento: 'Save Appointment',
            crea_referto: 'Create Report',
            aggiunto: 'Added',
            prestazioni_aggiunte: '{prestazione} new service added',
            prestazioni_gia_presenti: '{prestazione} is already in the list',
            prestazioni: 'Services',
            vai_ad_oggi: 'Go to Today',
            ricarica_eventi: 'Reload Events',
            calendario: 'Calendar',
            agenda: 'Agenda',
            quanti: 'How many?',
            denti_amalgama: 'Amalgam',
            denti_otturazioni: 'Fillings',
            denti_piombature: 'Lead Fillings',
            denti_altro: 'Other',
            gusti_desc: 'Preferred tastes',
            gusti: 'Tastes',
            alimentazione: 'Nutrition',
            tatuaggi: 'Tattoos',
            pressione_arteriosa: 'Blood Pressure',
            salute_dentale: 'Dental Health',
            a: 'to',
            aggiungi: 'Add',
            aggiungi_note: 'Add notes',
            aggiorna: 'Update',
            aggiorna_tabella: 'Update table',
            aggiornamento_eseguito: 'Update completed successfully!',
            anamnesi: 'Anamnesis',
            anno: 'Year',
            annulla: 'Cancel',
            annulla_modifica: 'Cancel edit',
            autenticazione_2FA: '2FA Authentication',
            avvia_timer: 'Start timer',
            avviso_date_con_date_disabilitate:
                'If the selected date range includes disabled dates, the system will generate as many associations as there are date ranges found.',
            azioni: 'Actions',
            benvenuto_descrizione: 'Order management and planning',
            benvenuto_titolo: 'Planner Bee.p',
            benvenuto_utente: 'Welcome',
            recapito_emergenza: 'Emergency contact',
            calcola_data_fine: 'Calculate estimated end date',
            calendario: 'Calendar',
            cambia_immagine: 'Change image',
            cambia_password: 'Change password',
            cambia_tema: 'Change theme',
            cambio_lingua: 'LANGUAGE CHANGE IN PROGRESS...',
            campo_richiesto: 'Required field',
            caricamento_dati: 'Loading data...',
            categorie: 'Categories',
            categoria: 'Category',
            tipologia: 'Operator Type',
            cerca: 'Search...',
            cerca_appuntamenti: 'Search Appointments',
            cerca_per_nome_cognome: 'Search by first or last name...',
            aliquota_iva: 'VAT Rate',
            descrizione_aliquota_iva: 'VAT Rate Description',
            prezzo_lordo: 'Gross Price',
            prezzo_di_acquisto: 'Purchase Price',
            giacenza: 'Stock',
            extra: 'Extra',
            paziente: 'Patient',
            registra_nuovo_paziente: 'Register new patient',
            ora: 'Time',
            medico: 'Doctor',
            struttura: 'Facility',
            tipologia_visita: 'Visit Type',
            data_creazione: 'Creation Date',
            prezzo_lordo: 'Gross Price',
            udm: 'Unit of Measure',
            chiudi: 'Close',
            cliente: 'Client',
            codice: 'Code',
            codice_email: 'Email code',
            partita_iva: 'VAT Number',
            codice_sdi: 'SDI Code',
            pec: 'PEC',
            peso: 'Weight',
            attuale_peso: 'Current Weight',
            altezza: 'Height',
            altezza_precisa: 'Height in cm',
            circonferenza_polso: 'Wrist circumference in cm',
            circonferenza_addome: 'Abdominal circumference in cm',
            gruppo_sanguigno: 'Blood group',
            sport: 'Do sports',
            sport_quali: 'Which sports?',
            sport_frequenza: 'Sports frequency',
            regime_alimentare: 'Dietary regimen',
            regime_alimentare_altro: 'Other dietary regimen',
            alimentazione_e_idratazione: 'Nutrition and hydration',
            rapporto_corpo_desc: 'Do you have a good relationship with your body?',
            rapporto_corpo: 'Relationship with your body',
            capelli_desc: 'Have your hair undergone coloring treatment, dye, other?',
            capelli_descrizione: 'Hair treatment description',
            acqua: 'Water',
            iban: 'IBAN',
            codice_autenticazione: 'Authentication code',
            codice_inviato: 'Code sent! Check your email to continue.',
            codice_obbligatorio: 'The code is required!',
            codice_recupera_password_verificato:
                'Code correctly verified, proceed with entering the new password',
            codice_testo: 'Enter the code that was sent to you by email before the time expires',
            cognome: 'Surname',
            colore: 'Color',
            collaboratori_esterni: 'External collaborators',
            commessa: 'Order',
            esporta_excel: 'Export excel',
            transazioni_disponibili_dopo_creazione: 'Transactions will be available after creation',
            inserisci_saldo_iniziale_o_lascia_vuoto:
                'At the moment, enter the initial balance of the patient or leave blank to set €0.00',
            commessa_duplicata: 'Order duplicated successfully!',
            commessa_eliminata: 'Order deleted successfully!',
            commessa_ricevuta: 'Order received',
            commessa_risorsa_aggiornata: 'Order updated successfully!',
            commesse_importate: 'Orders imported successfully',
            concludi: 'Conclude',
            conferma: 'Confirm',
            conferma_eliminazione: 'Are you sure you want to delete the selected data?',
            conferma_eliminazione_transazione:
                'Are you sure you want to delete the transaction? This will only delete the transaction, the remaining credit will not be modified.',
            costo_finale: 'Final cost',
            crea: 'Create',
            creatoIl: 'Created on',
            creazione_eseguita: 'Creation executed successfully!',
            data: 'Date',
            data_fine: 'End date',
            data_fine_maggiore_data_inizio: 'The end date must be greater than the start date',
            data_fine_stimata: 'Estimated end date',
            data_inizio: 'Start date',
            data_intervento: 'Intervention date',
            data_nascita: 'Date of birth',
            luogo_nascita: 'Place of birth',
            provincia_nascita: 'Province of birth',
            stato_nascita: 'Country of birth',
            data_ultimo_login: 'Last login',
            dati_non_disponibili: 'Data not available',
            dati_personali: 'Personal data',
            da_pianificare: 'To be planned',
            denominazione: 'Denomination',
            descrizione: 'Description',
            dettagli_base: 'Basic details',
            di: 'of',
            dipendente_cliente: 'Client employee',
            durata_attuale: 'Current hours',
            durata_giornata_lavorativa: 'Working day duration',
            durata_prevista: 'Estimated hours',
            duplica_commessa: 'Duplicate order',
            esporta: 'Export',
            email: 'Email',
            emailResetPassInviata: 'Password reset email sent to the specified user.',
            email_cliente: 'Client email',
            email_invio_rapportino: 'Report sending email',
            elimina: 'Delete',
            elimina_commessa: 'Delete order',
            errore: 'Error!',
            errore_generazione_qr: 'QR generation error!',
            error_effettua_login: 'Log in to continue',
            error_sottotitolo_401:
                "<span>We're sorry, but you don't have the necessary permissions to complete the operation. <br/>Try again later and if the error persists, contact our technical team providing details about the operation. <br/>Thank you for your understanding and patience.</span>",
            error_sottotitolo_404:
                '<span>We apologize, but the page you are looking for is not available or has been moved. <br/>Check the URL and make sure it is correct. <br/>If the problem persists, it could be due to an obsolete link or a deleted resource.</span>',
            error_sottotitolo_generale:
                "<span>We're sorry, an unexpected error occurred during the operation. <br/>Try again later and if the error persists, contact our technical team providing details about the operation. <br/>Thank you for your understanding and patience.</span>",
            error_titolo_401: 'Unauthorized',
            error_titolo_404: 'Page not found',
            error_titolo_generale: 'Error encountered',
            error_torna_pagina_iniziale: 'Return to the home page',
            favorite_page_pagina_rimossa: 'Page removed from favorites',
            ferma_timer: 'Stop timer',
            file_e_documenti: 'Files and documents',
            file_troppo_grande: 'File too large',
            fornitura: 'Supply',
            genera_password: 'Generate password',
            genera_qr: 'Generate QR',
            gestione_orari: 'Time management',
            grafico: 'Chart',
            id: 'ID',
            immagine_profilo: 'Profile picture',
            immagine_profilo_aggiornata: 'Profile picture updated successfully!',
            importa: 'Import',
            inattivita_descrizione_1: 'Prolonged inactivity detected.',
            inattivita_descrizione_2: 'For security reasons, you have been logged out.',
            inattivita_titolo: 'Inactivity detected!',
            indirizzo_ip: 'IP address',
            indirizzo_luogo_intervento: 'Intervention place address',
            informazione: 'Information',
            inserisci_mail_valida: 'Enter a valid email',
            invia_credenziali: 'Send credentials via email',
            invia_file: 'Send file',
            invia_rapportino: 'Send report',
            inviata_amministrazione: 'Sent to administration',
            inviata_cliente: 'Sent to client',
            km_percorsi: 'Km traveled',
            livello: 'Level',
            lista: 'List',
            completa_profilo: 'Complete all fields to continue',
            login_aggiorna_accedi: 'Update and log in',
            login_attendi: 'Please wait...',
            login_attendi_riprova: 'Wait to try again!',
            login_benvenuto: 'Welcome!',
            login_campo_non_sicuro: 'Insecure field!',
            login_campi_obbligatori: 'Enter both username and password to continue',
            login_codice_scaduto: 'Code expired! try again to continue',
            login_conferma_password: 'Confirm password',
            login_nuova_password: 'New password',
            login_controlla_mail: 'Check emails to continue',
            login_effetta_accesso: 'Log in',
            login_email_reset_pass_inviata: 'Password reset email sent to the specified user.',
            login_livello_sicurezza_password: 'Password security level',
            login_password: 'Password',
            login_password_dimenticata: 'Forgot your password?',
            login_password_non_uguali: 'Passwords do not match',
            login_reset_password: 'Reset password',
            login_scegli_autenticazione: 'Select the authentication method',
            login_submit_text: 'Login',
            login_suggerimenti_password: 'Password suggestions',
            login_suggerimenti_password_1: 'Password must contain at least one lowercase letter',
            login_suggerimenti_password_2: 'Password must contain at least one uppercase letter',
            login_suggerimenti_password_3: 'Password must contain at least one number',
            login_suggerimenti_password_4: 'Password must contain at least one special character',
            login_suggerimenti_password_5: 'Password must contain at least 8 characters',
            login_timeout_codice: 'Verification code expired',
            login_troppe_richieste: 'You have made too many requests!',
            login_usa_password: 'Use your password',
            login_username: 'Username',
            login_username_reset_password:
                "Enter the username for which you want to request a password reset in the 'username' field.",
            login_utente_non_trovato: 'Unable to find the entered user!',
            logout_conferma_disconnessione: 'Confirm',
            logout_disconnetti: 'Disconnect',
            logout_disconnessione: 'Disconnection',
            logout_messaggio_disconnessione: 'Are you sure you want to disconnect?',
            luogo_intervento: 'Intervention place',
            menu_amministratori: 'Administrators',
            menu_amministratori_tooltip: 'Registry - Administrators',
            menu_anagrafiche: 'Registry',
            menu_categorie_commesse: 'Order categories',
            menu_categorie_commesse_tooltip: 'Registry - Order categories',
            menu_tipologia_operatori: 'Operator Type',
            menu_tipologia_operatori_tooltip: 'Registry - Operator Type',
            menu_clienti: 'Clients',
            menu_clienti_tooltip: 'Registry - Clients',
            menu_appuntamenti: 'Appointments',
            menu_appuntamenti_tooltip: 'Appointments',
            menu_dashboard: 'Dashboard',
            menu_strutture: 'Facilities',
            menu_strutture_tooltip: 'Registry - Facilities',
            menu_impostazioni: 'Settings',
            menu_occupazione: 'Occupation',
            menu_priorita_commesse: 'Order priorities',
            menu_priorita_commesse_tooltip: 'Registry - Order priorities',
            menu_prodotti: 'Products',
            menu_prodotti_tooltip: 'Registry - Products',
            menu_rapportini: 'Reports',
            menu_rapportini_nuovo: 'Create new',
            menu_rapportini_nuovo_tooltip: 'Reports - Create new',
            menu_rapportini_nuovo_rapportino: 'New report',
            menu_rapportini_resoconto: 'Summary',
            menu_rapportini_resoconto_tooltip: 'Reports - Summary',
            menu_macro_gruppi: 'Macro Groups',
            menu_macro_gruppi_tooltip: 'Registry - Macro Groups',
            menu_pazienti: 'Patients',
            menu_pazienti_tooltip: 'Registry - Patients',
            menu_sconti: 'Discounts',
            menu_sconti_tooltip: 'Registry - Discounts',
            menu_tag_commesse: 'Order tags',
            menu_tag_commesse_tooltip: 'Registry - Order tags',
            menu_utilita_calendario_eventi: 'Event calendar',
            menu_utilita_calendario_eventi_tooltip: 'Utilities - Event calendar',
            menu_utilita: 'Utilities',
            menu_utilita_archivio: 'Archive',
            menu_utilita_archivio_tooltip: 'Utilities - Archive',
            menu_utilita_chat: 'Chat',
            menu_utilita_chat_tooltip: 'Utilities - Chat',
            menu_utilita_log: 'Log',
            menu_utilita_log_tooltip: 'Utilities - Log',
            messaggio_conferma_eliminazione_selezionati: 'Data deleted successfully!',
            messaggio_conferma_ripristino_selezionati: 'Data restored successfully!',
            messaggio_duplicazione: 'Duplicate the order?',
            messaggio_eliminazione: 'Delete the order?',
            messaggio_eliminazione_selezionati:
                'Are you sure you want to delete the selected data?',
            messaggio_ripristina_selezionati: 'Are you sure you want to restore the selected data?',
            abitudini_vita: 'Life habits',
            messaggio_eliminato: 'Message deleted',
            dieta_libera_varia: 'Free and varied diet',
            dieta_controllata: 'Controlled for',
            digestione: 'Regular digestion',
            medico_curante: 'Primary care physician',
            storia_malattie_paziente: 'Patient disease history',
            malattie_cuore: 'Heart diseases',
            malattie_cuore_descrizione: 'Heart diseases description',
            pressione: 'Pressure',
            allergie: 'Allergies',
            quali_allergie: 'Which allergies?',
            diabete: 'Diabetes',
            tipologia_diabete: 'Diabetes type',
            epatite_virale: 'Viral hepatitis',
            tipologia_epatite: 'Hepatitis type',
            malattie_fegato: 'Liver diseases',
            malattie_fegato_descrizione: 'Liver diseases description',
            malattie_renali: 'Kidney diseases',
            malattie_renali_descrizione: 'Kidney diseases description',
            malattie_tiroide: 'Thyroid diseases',
            malattie_tiroide_descrizione: 'Thyroid diseases description',
            malattie_stomaco_tubo_digerente: 'Stomach or digestive tract diseases',
            malattie_stomaco_tubo_digerente_descrizione:
                'Stomach or digestive tract diseases description',
            malattie_polmonari: 'Lung diseases',
            malattie_polmonari_descrizione: 'Lung diseases description',
            malattie_veneree: 'Venereal diseases',
            malattie_veneree_descrizione: 'Venereal diseases description',
            malattie_nervose_depressive: 'Nervous and depressive diseases',
            malattie_nervose_depressive_descrizione: 'Nervous and depressive diseases description',
            malattie_oculari: 'Eye diseases',
            malattie_oculari_descrizione: 'Eye diseases description',
            malattie_sangue_emorragie: 'Blood diseases and hemorrhages',
            malattie_sangue_emorragie_descrizione: 'Blood diseases and hemorrhages description',
            malattie_non_elencate: 'Unlisted diseases',
            alitosi: 'Halitosis',
            conseguenze_particolari:
                'Particular consequences following the administration of anesthetics, antibiotics, analgesics or other drugs?',
            esami_radiografici: 'Radiographic examinations',
            esami_ematici: 'Radiation therapy',
            esami_radiografici_descrizione: 'Radiographic examinations description',
            esami_ematici_descrizione: 'Radiation therapy description',
            malattie_gravi_interventi_chirurgici: 'Serious illnesses and/or surgical interventions',
            malattie_gravi_interventi_chirurgici_descrizione:
                'Description of serious illnesses and/or surgical interventions',
            menu_tipologie_visite: 'Visit types',
            menu_tipologie_visite_tooltip: 'Registry - Visit types',
            alvo: 'Regular bowel movements',
            per_uomini: 'For men',
            sonno: 'Regular sleep',
            seleziona_elementi_da_esportare: 'Select items to export',
            pdf_generato_correttamente: 'PDF generated correctly',
            disancora_elemento: 'Unanchor item',
            timeline_giornaliera: 'Daily timeline',
            stato: 'State',
            fumo: 'Smoke',
            setup_salvato: 'Window setup saved',
            setup_rimosso: 'Window setup removed',
            visualizza_tabs: 'Switch to tabs view',
            fame_nervosa_desc: 'Do you suffer from nervous hunger?',
            stitichezza_desc: 'Do you suffer from constipation?',
            stitichezza: 'Constipation',
            fame_nervosa: 'Nervous hunger',
            tipo_acqua: 'Type of water',
            litri_giorno: 'Liters of water per day',
            seleziona_alimenti_preferiti: 'Select preferred foods (multiple choices possible)',
            quanto_fumo: 'Daily quantity',
            tempo_fumo: 'For how long?',
            numero_caffe: 'Number of daily coffees',
            caffe: 'Coffee',
            alcol: 'Alcohol',
            quali_alcol: 'Which alcoholic drinks?',
            farmaci: 'Taking medications and/or drugs?',
            quali_farmaci: 'Which medications and/or drugs?',
            tempo_farmaci: 'For how long?',
            perche_farmaci: 'Why?',
            antitetanica: 'Tetanus vaccine',
            ultimo_antitetanica: 'Date of last administration',
            professione: 'Profession',
            per_donne: 'For women',
            menarca_anni: 'Menarche',
            menarca_anni_testo: 'Years',
            ultimo_ciclo: 'Last cycle',
            ciclo_regolare: 'Regular cycle',
            gravidanze: 'Pregnancies',
            numero_gravidanze: 'Number of pregnancies',
            modifica: 'Edit',
            mostra_dettagli: 'Show details',
            mostra_ore: 'View hours',
            nessuna_chat_selezionata: 'No chat selected',
            nessun_dato: 'No data present',
            seleziona_anamnesi: 'Select anamnesis',
            nessuna_email_cliente: 'No email present for the selected client',
            nessun_cliente_selezionato: 'No client selected',
            nessun_dato_archiviato: 'No data marked as archived is present',
            nominativo: 'Name',
            nominativo_cliente: 'Client name',
            nominativo_dipendente: 'Client employee name',
            nome: 'Name',
            sesso: 'Gender',
            citta: 'City',
            codice_fiscale: 'Tax Code',
            cap: 'ZIP Code',
            indirizzo: 'Address',
            provincia: 'Province',
            non_programmato: 'Not scheduled',
            note: 'Notes',
            note_amministrative: 'Administrative notes',
            note_intervento: 'Intervention notes',
            numero: 'Number',
            numero_documento: 'Document number',
            oggi: 'Today',
            totali: 'Totals',
            compila_tutti_i_campi_obbligatori: 'Fill in all required fields',
            occupazione: 'Occupation',
            ore_effettive: 'Actual hours',
            ore_lavorate: 'Hours worked',
            ore_lavorate_breve: 'hrs worked',
            ore_lavorate_breve_header: 'Hrs worked',
            ore_lavorate_effettive: 'Actual hours worked',
            ore_lavorate_effettive_breve_header: 'Actual hrs',
            ore_viaggio: 'Travel hours',
            modifica_referto: 'Edit report',
            oppure: 'or',
            parametri: 'Parameters',
            pdf_generato_con_successo: 'PDF generated successfully',
            errore_generazione_pdf: 'Error during PDF generation',
            referto_aggiornato_con_successo: 'Report updated successfully',
            errore_aggiornamento_referto: 'Error during report update',
            aggiorna_referto: 'Update report',
            password: 'Password',
            password_aggiornata: 'Password updated successfully!',
            password_cambiata: 'Password changed successfully!',
            password_gia_usata:
                'The password has already been used before! Enter another one to continue.',
            percentuale_completamento: 'Progress',
            pianificazione: 'Planning',
            privacy_policy: `<h1>PRIVACY POLICY</h1>
                  <p>This page describes how the site is managed in reference to the processing of personal data of users who consult it, as well as methods and purposes of processing personal data.</p>
                  <p>This information is also provided pursuant to art.13-14 EU Reg. 2016/679 to those who interact with web services accessible electronically from the address.</p>
                  <p>The information is provided only for this site and not for other websites that may be consulted through our links, for which we are not responsible in any way.</p>
                  <p>
                      In the capacity of Data Controller of your personal data, pursuant to and for the effects of EU Reg. 2016/679 - GDPR, we hereby inform you that the aforementioned legislation provides for the protection of data subjects with respect to
                      the processing of personal data and that such processing will be based on the principles of correctness, lawfulness, transparency and protection of your privacy and your rights.
                  </p>
                  <p>Your personal data will be processed in accordance with the legislative provisions of the aforementioned legislation and the confidentiality obligations provided therein.</p>
                  <h2>TYPES OF DATA PROCESSED</h2>
                  <h3>Navigation Data</h3>
                  <p>
                      The computer systems and software procedures responsible for the operation of this website acquire, during their normal operation, some personal data whose transmission is implicit in the use of Internet communication protocols. This information is not collected to be associated with identified data subjects, but by their very nature could, through processing and associations with data held by third parties,
                      allow users to be identified. This category of data includes IP addresses or domain names of computers used by users connecting to the site, addresses in URI (Uniform Resource
                      Identifier) notation of requested resources, the time of the request, the method used in submitting the request to the server, the size of the file obtained in response, the numerical code indicating the status of the response given by the
                      server (successful, error, etc.) and other parameters relating to the user's operating system and computing environment. This data is used solely for the purpose of obtaining anonymous statistical information on the use of the site and to
                      control its correct functioning and is deleted immediately after processing. The data could be used to ascertain liability in case of hypothetical computer crimes against the site.
                  </p>
                  <h3>Data voluntarily provided by the user</h3>
                  <p>
                      The optional, explicit and voluntary sending of email to the addresses indicated on this site, as well as the completion of forms for sending specific requests involves the subsequent acquisition of the sender's address, necessary to respond to requests, as well as any other personal data entered in the message or form.
                      <br />Specific summary information is reported or displayed on site pages prepared for particular services on request.
                  </p>
                  <h2>CONSEQUENCES OF REFUSAL TO PROVIDE DATA</h2>
                  <p>
                      Apart from what is specified for navigation data, the user is free to provide personal data reported in request forms, subscription to mailing lists or otherwise indicated in contacts to request the sending of informational, technical or commercial material or other communications. Their failure to provide it may result in the inability to obtain what is requested.
                  </p>
                  <h2>PROCESSING METHODS</h2>`,
            prodotti: 'Products',
            qrcode: 'QR Code',
            prodotto: 'Product',
            prodotti_relativi_ordine: 'Order-related products',
            prodotti_utilizzati: 'Products used',
            profilo_aggiornato: 'Profile updated successfully!',
            profilo_personale: 'Personal profile',
            rapportini: 'Reports',
            referti: 'Medical Reports',
            oggetto: 'Subject',
            menu_referti_nuovo_tooltip: 'Create a new medical report',
            menu_referti_nuovo: 'New Medical Report',
            menu_referti_aggiorna: 'Update Medical Report',
            menu_referti_aggiorna_tooltip: 'Update an existing medical report',
            menu_referti_visualizza: 'View Medical Reports',
            menu_referti_resoconto: 'Medical Reports Summary',
            oggetto_referto: 'Medical Report Subject',
            menu_referti: 'Medical Reports',
            nuovo_referto_medico: 'New Medical Report',
            data_referto: 'Report Date',
            esame_obiettivo: 'Physical Examination',
            terapia_prescritta: 'Prescribed Therapy',
            note_aggiuntive: 'Additional Notes',
            firma: 'Signature',
            fattori_allevianti: 'Alleviating factors',
            farmaci_assunti: 'Medications taken',
            terapie_precedenti: 'Previous therapies',
            disturbi_associati: 'Associated disorders',

            // Translations for Excel patient import
            paziente_gia_presente: 'Patient already present',
            paziente_aggiornato: 'Patient updated',
            paziente_aggiunto: 'Patient added',
            dati_importati_con_successo: 'Data imported successfully',
            errore_importazione: 'Error during import',
            formato_file_non_supportato: 'File format not supported',
            seleziona_file_excel: 'Select Excel file',
            anteprima_dati: 'Data preview',
            conferma_importazione: 'Confirm import',
            pazienti_da_importare: 'Patients to import',
            pazienti_importati: 'Patients imported',
            pazienti_aggiornati: 'Patients updated',
            processing_import: 'Processing import...',
            file_non_valido: 'Invalid file',
            dati_non_validi: 'Invalid data in file',
            conferma_creazione_commessa_con_padre:
                'Are you sure you want to create a child project? If the parent project has a schedule, it will be deleted.',
            utenti_in_carico: 'Users in charge',
            lascia_incarico: 'Leave assignment',
            conferma_lascia_incarico:
                'Are you sure you want to leave the assignment of this project?',
            conferma_presa_in_carico: 'Are you sure you want to take charge of this project?',
            commessa_presa_in_carico: 'Project taken in charge correctly!',
            no_utente_in_carico: 'No user has taken charge of this project yet',
            prendi_in_carico: 'Take charge',
            conferma_svuotamento_tabella: 'Are you sure you want to empty the table?',
            svuotamento_tabella: 'Empty table',
            svuota_tabella: 'Empty table',
            codice_otp: 'OTP Code',
            codice_otp_testo: 'Enter the OTP code generated by your authentication app.',
            troppi_errori_verifica_codice:
                'Too many errors in code verification, you are about to be redirected to the login page.',
            codice_inserito_errato: 'The entered code is incorrect, try again.',
            prezzo_totale: 'Total price',
            tentativi_rimanenti: 'Remaining attempts: ',
            periodo: 'Period',
            mostra_utenti_selezionati: 'Show users',
            nascondi_utenti_selezionati: 'Hide users',
            visualizza: 'View',
            crea_copia: 'Create copy',
            ricorda_calcola_prezzi: "Remember to calculate prices if you haven't done it yet!",
            modifica_copia: 'Edit copy',
            totale: 'Total',
            genera_pdf: 'Generate PDF',
            desideri_generare_pdf: 'Do you want to generate the PDF',
            creato_con_successo: 'Created successfully',
            suggerimenti_dialog_vuota: `To get started, you can open an existing item by clicking the 'Details' button on the right of the table, or create a new one using the Toolbar above.\nIf you previously saved a setup, you can always retrieve it from the Toolbar.`,
            setup_non_trovato: 'Setup not found',
            setup_ottenuto: 'Setup obtained successfully',
            get_setup: 'Get saved setup',
            avviso: 'Warning',
            tooltip_password_temporanea:
                'The temporary password will be available for login only once: once the first login is made, the user will be forced to change it!',
            creazione_gia_in_corso: 'Creation already in progress!',
            chiudi_elemento: 'Close element',
            archivia: 'delete',
            seleziona_file: 'Select file',
            importazione_dati: 'Data import',
            importazione_dati_riuscita: 'Data import successful!',
            importazione_dati_fallita: 'Data import failed!',
            importazione_dati_errore: 'Error during data import!',
            importazione_in_corso: 'Import in progress...',
            elementi_importati: 'Imported elements',
            ragione_sociale: 'Company name',
            sigla: 'Abbreviation',
            descma: 'Descma',
            cod_fornitore: 'Supplier code',
            cod_prodotto: 'Product code',
            prezzo_netto: 'Net price',
            prezzo_listino: 'List price',
            stato_prodotto: 'Product status',
            barcode: 'Barcode',
            unita_misura: 'Unit of measure',
            serie_vendita: 'Sales series',
            cod_numerico: 'Numeric code',
            qta_min_acquistabile: 'Min. purchasable qty',
            gruppo_1: 'Group 1',
            gruppo_2: 'Group 2',
            gruppo_3: 'Group 3',
            moltipli_prezzo: 'Price multiplier',
            moltipli_prezzo_netto: 'Net price multiplier',
            iva: 'VAT',
            preferiti: 'Favorites',
            dettagli: 'Details',
            cvs_headers_errore: 'Error in uploaded file! Missing headers',
            desc_serie_vendita: 'Sales series description',
            data_validita: 'Validity date',
            sconto1: 'Discount 1',
            sconto2: 'Discount 2',
            sconto3: 'Discount 3',
            sconto4: 'Discount 4',
            sconto5: 'Discount 5',
            seleziona_righe_prima:
                'To delete items, first select rows using the checkbox on the left of the table!',
            data_non_valida: 'Invalid date',
            prezzo_ora: 'Hourly rate',
            commessa_padre: 'Parent project',
            visualizza_firme: 'View signatures',
            pdf_rapportino: 'Report PDF',
            visualizza_rapportino_pdf: 'View report PDF',
            scarica_rapportino_pdf: 'Download report PDF',
            elimina_rapportino_pdf: 'Delete report PDF',
            generazione_pdf: 'PDF generation in progress...',
            generazione_pdf_completata: 'PDF generation completed successfully!',
            programmata: 'Scheduled',
            in_corso: 'In progress',
            completata: 'Completed',
            info_commesse_pianificazione: 'PROJECT INFO',
            modifica_creazione: 'Creation and Editing',
            visualizza_commesse: 'View Projects',
            step_commesse: 'Project Steps',
            pianificazione_commesse: 'Project Planning',
            descrizione_modifica_creazione:
                'Here you can create new projects and edit them easily.',
            descrizione_visualizzazione: 'Access the project list for a complete overview.',
            descrizione_step: 'Each project is divided into various steps that can be monitored.',
            conferma_pianifica: 'Do you want to plan the project just created?',
            descrizione_pianificazione:
                'Project planning consists in organizing all activities necessary to complete it efficiently.',
            popup_modifica_creazione: `
              <p><strong>By pressing the "+" button at the top right you can insert new projects with related data:</strong></p>
              <ul>
                <li><strong>Name:</strong> Unique identifier of the project to facilitate its management and recognition.</li>
                <br>
                <li><strong>Client:</strong> Name of the client for whom the project is created.</li>
                <br>
                <li><strong>Parent project:</strong> Option to create hierarchies between projects, assigning a main project (useful for dividing more complex projects).</li>
                <br>
                <li><strong>Priority:</strong> Indicates the urgency of the project, choosing between High, Medium or Low to facilitate activity organization.</li>
                <br>
                <li><strong>Description:</strong> Free text in which to specify details and fundamental information about the project content.</li>
                <br>
                <li><strong>Notes:</strong> Section to add annotations, comments or any additional information useful for project management.</li>
              </ul>
              `,
            popup_visualizza_commesse: `
                <p><strong>Project Visualization</strong></p>
                <p>Projects are organized and displayed with clear and structured criteria to ensure effective and intuitive management.
                Visualization can occur based on different parameters:</p>
                <ul>
                  <li>
                    <strong>Name:</strong> Projects are identified through their unique name, allowing immediate and precise search.
                    This criterion is useful for those who manage numerous projects and need to recognize them easily.
                  </li>
                  <br>
                  <li>
                    <strong>Priority:</strong> Each project is classified based on urgency level, which can be <strong>High</strong>, <strong>Medium</strong> or <strong>Low</strong>.
                    This filter allows for effective activity organization, giving priority to the most important or urgent projects.
                  </li>
                  <br>
                  <li>
                    <strong>Creation Date:</strong> Projects are listed chronologically, allowing quick identification of the most recent ones
                    or consulting older ones for possible revisions or updates. This visualization method is useful for tracking
                    the evolution of activities over time.
                  </li>
                </ul>`,
            popup_step_commesse: `
                <p><strong>Project Hierarchy Visualization</strong></p>
                <p>By pressing the "<strong>></strong>" button, you will be able to expand and view the hierarchical structure of projects.</p>
                <ul>
                  <li><strong>Main projects:</strong> Will initially be shown in a compact list for clearer visualization.</li>
                  <br>
                  <li><strong>Subordinate projects:</strong> By clicking the expansion button, you can see the projects linked to each main project.</li>
                  <br>
                  <li><strong>Intuitive organization:</strong> Thanks to this structure, it is possible to manage complex projects by dividing activities into clearer and more easily navigable sections.</li>
                </ul>`,
            popup_pianifazione_commesse: `
            <p><strong>Project Planning</strong></p>
            <p>Project planning is essential to ensure clear organization and efficient activity management. Each project is structured based on several fundamental parameters:</p>
            <ul>
              <li><strong>Main project:</strong> Identifier of the main project, useful for creating a hierarchy between activities and dividing more complex projects.</li>
              <br>
              <li><strong>Start and end date:</strong> Each project is scheduled with a start date and completion date, allowing for deadline setting and progress monitoring over time.</li>
              <br>
              <li><strong>Collaborators:</strong> The project can be assigned to one or more collaborators, facilitating teamwork and task distribution among various team members.</li>
              <br>
              <li><strong>Project status:</strong> Each project can be in one of the following states:</li>
              <ul>
                <li><strong>In progress:</strong> The project is active and activities are being developed.</li>
                <br>
                <li><strong>Completed:</strong> All activities have been successfully concluded.</li>
                <br>
                <li><strong>Not completed:</strong> The project was interrupted or not completed according to the initial planning.</li>
                <br>
              </ul>
            </ul>
          <p>Thanks to this organizational structure, project planning becomes clearer and allows precise control over every phase of work.</p>`,
            mostra_commesse: 'Show',
            funzionamento_filtri: 'Filter operation',
            descrizione_filtri: `
           <h2>1. Collaborators Filter <i class="fal fa-solid fa-users"></i></h2>
            <p>Allows selecting one or more users to view only elements (projects, activities, resources) they participate in.</p>
            <p><strong>OR Logic:</strong> Shows elements with at least one of the selected collaborators (e.g., Marco OR Luca).</p>
            <p><strong>AND Logic:</strong> Shows only elements where all selected collaborators are present (e.g., Marco AND Luca together).</p>

            <h2>2. Categories Filter <i class="fal fa-solid fa-list"></i></h2>
            <p>Filters by content type (e.g., Marketing, Training...). Supports single or multiple selection.</p>
            <p><strong>Recommended logic:</strong> OR. Example: selecting "Marketing" and "Sales" shows elements belonging to either one.</p>

            <h2>3. Creator Users Filter <i class="fa-solid fa-user-tie"></i></h2>
            <p>Filters based on who created the element (e.g., "show all resources created by Marco").</p>

            <h2>AND vs OR Logic <i class="fal fa-solid fa-gears"></i></h2>
            <ul>
              <li><strong>Collaborators:</strong> AND = all present / OR = at least one present</li>
              <li><strong>Categories:</strong> AND = all / OR = any one</li>
              <li><strong>Clients:</strong> AND = all / OR = any one</li>
              <li><strong>Creators:</strong> AND = makes little sense / OR = any one</li>
            </ul>
            <p><strong>Note:</strong> OR logic is the most intuitive and recommended in most cases.</p>`,
            // Missing medical and system translations
            codice_autenticazione: 'Authentication code',
            codice_inviato: 'Code sent! Check your email to continue.',
            codice_obbligatorio: 'Code is required!',
            codice_recupera_password_verificato:
                'Code successfully verified, proceed with entering the new password',
            codice_testo: 'Enter the code sent to you via email before the time expires',
            cognome: 'Last name',
            colore: 'Color',
            collaboratori_esterni: 'External collaborators',
            commessa: 'Project',
            esporta_excel: 'Export excel',
            transazioni_disponibili_dopo_creazione: 'Transactions will be available after creation',
            inserisci_saldo_iniziale_o_lascia_vuoto:
                "Currently, enter the patient's initial balance or leave blank to set €0.00",
            commessa_duplicata: 'Project successfully duplicated!',
            commessa_eliminata: 'Project successfully deleted!',
            commessa_ricevuta: 'Project received',
            commessa_risorsa_aggiornata: 'Project successfully updated!',
            commesse_importate: 'Projects successfully imported',
            concludi: 'Conclude',
            conferma: 'Confirm',
            conferma_eliminazione: 'Are you sure you want to delete the selected data?',
            conferma_eliminazione_transazione:
                'Are you sure you want to delete the transaction? By doing so, only the transaction will be deleted, the remaining credit will not be modified.',
            costo_finale: 'Final cost',
            crea: 'Create',
            creatoIl: 'Created on',
            creazione_eseguita: 'Creation completed successfully!',
            data: 'Date',
            data_fine: 'End date',
            data_fine_maggiore_data_inizio: 'The end date must be greater than the start date',
            data_fine_stimata: 'Estimated end date',
            data_inizio: 'Start date',
            data_intervento: 'Intervention date',
            data_nascita: 'Date of birth',
            luogo_nascita: 'Place of birth',
            provincia_nascita: 'Province of birth',
            stato_nascita: 'Country of birth',
            data_ultimo_login: 'Last login',
            dati_non_disponibili: 'Data not available',
            dati_personali: 'Personal data',
            da_pianificare: 'To be planned',
            denominazione: 'Name',
            descrizione: 'Description',
            dettagli_base: 'Basic details',
            di: 'of',
            dipendente_cliente: 'Client employee',
            durata_attuale: 'Current hours',
            durata_giornata_lavorativa: 'Workday duration',
            durata_prevista: 'Planned hours',
            duplica_commessa: 'Duplicate project',
            esporta: 'Export',
            email: 'Email',
            emailResetPassInviata: 'Password reset email sent to the specified user.',
            email_cliente: 'Client email',
            email_invio_rapportino: 'Report email',
            elimina: 'Delete',
            elimina_commessa: 'Delete project',
            errore: 'Error!',
            errore_generazione_qr: 'QR generation error!',
            error_effettua_login: 'Log in to continue',
            error_sottotitolo_401:
                '<span>Sorry, you do not have the necessary permissions to complete the operation. <br/>Try again later, and if the error persists, contact our technical team providing details about the operation. <br/>Thank you for your understanding and patience.</span>',
            error_sottotitolo_404:
                '<span>We apologize, but the page you are looking for is not available or has been moved. <br/>Check the URL and make sure it is correct. <br/>If the problem persists, it may be due to an outdated link or a deleted resource.</span>',
            error_sottotitolo_generale:
                '<span>Sorry, an unexpected error occurred during the operation. <br/>Try again later, and if the error persists, contact our technical team providing details about the operation. <br/>Thank you for your understanding and patience.</span>',
            error_titolo_401: 'Unauthorized',
            error_titolo_404: 'Page not found',
            error_titolo_generale: 'Error encountered',
            error_torna_pagina_iniziale: 'Return to the home page',
            favorite_page_pagina_rimossa: 'Page removed from favorites',
            ferma_timer: 'Stop timer',
            file_e_documenti: 'Files and documents',
            file_troppo_grande: 'File too large',
            fornitura: 'Supply',
            genera_password: 'Generate password',
            genera_qr: 'Generate QR',
            gestione_orari: 'Time management',
            grafico: 'Chart',
            id: 'ID',
            immagine_profilo: 'Profile picture',
            immagine_profilo_aggiornata: 'Profile picture updated successfully!',
            importa: 'Import',
            inattivita_descrizione_1: 'Prolonged inactivity detected.',
            inattivita_descrizione_2: 'For security reasons, you have been logged out.',
            inattivita_titolo: 'Inactivity detected!',
            indirizzo_ip: 'IP address',
            indirizzo_luogo_intervento: 'Intervention location address',
            informazione: 'Information',
            inserisci_mail_valida: 'Enter a valid email',
            invia_credenziali: 'Send credentials via email',
            invia_file: 'Send file',
            invia_rapportino: 'Send report',
            inviata_amministrazione: 'Sent to administration',
            inviata_cliente: 'Sent to client',
            km_percorsi: 'Km traveled',
            livello: 'Level',
            lista: 'List',
            completa_profilo: 'Complete all fields to continue',
            // Add remaining translations from the comprehensive list
            sconto_percentuale: 'Percentage discount',
            recupera_password: 'Recover password',
            inserisci_Username: 'Enter username',
            inserisci_Username_per_recupero_passoword:
                'Enter your username to request password recovery',
            verifica_il_codice: 'Verify the code',
            codice_tramite_email: 'Enter the code that was sent to you via email',
            resetta_password: 'Reset password',
            generatore_password:
                'Use the generator to create a strong and secure password. You will receive an email with the new password.',
            torna_al_login: 'Back to login',
        },
        fr: {
            a: 'a',
            aggiungi: 'Ajouter',
            aggiungi_note: 'Ajouter des notes',
            aggiorna: 'Mettre à jour',
            aggiorna_tabella: 'Mettre à jour le tableau',
            aggiornamento_eseguito: 'Mise à jour effectuée avec succès!',
            anno: 'Année',
            annulla: 'Annuler',
            annulla_modifica: 'Annuler la modification',
            autenticazione_2FA: 'Authentification 2FA',
            avvia_timer: 'Démarrer le minuteur',
            avviso_date_con_date_disabilitate:
                "Si la plage de dates sélectionnée comprend des dates désactivées, le système générera autant d'associations que de plages de dates trouvées.",
            azioni: 'Actions',
            benvenuto_descrizione: 'Gestion et planification des projets',
            benvenuto_titolo: 'Planner Bee.p',
            benvenuto_utente: 'Bienvenue',
            calcola_data_fine: 'Calculer la date de fin estimée',
            calendario: 'Calendrier',
            cambia_immagine: "Changer l'image",
            cambia_password: 'Changer le mot de passe',
            cambia_tema: 'Changer le thème',
            cambio_lingua: 'CHANGEMENT DE LANGUE EN COURS...',
            campo_richiesto: 'Champ requis',
            caricamento_dati: 'Chargement des données en cours...',
            categorie: 'Catégories',
            categoria: 'Catégorie',
            cerca: 'Rechercher...',
            cerca_appuntamenti: 'Rechercher des Rendez-vous',
            cerca_per_nome_cognome: 'Rechercher par prénom ou nom...',
            chiudi: 'Fermer',
            cliente: 'Client',
            codice: 'Code',
            codice_autenticazione: "Code d'authentification",
            codice_inviato: 'Code envoyé! Vérifiez votre e-mail pour continuer.',
            codice_obbligatorio: 'Le code est obligatoire!',
            codice_recupera_password_verificato:
                'Code vérifié avec succès, procédez à la saisie du nouveau mot de passe',
            codice_testo:
                "Saisissez le code qui vous a été envoyé par e-mail avant l'expiration du délai",
            cognome: 'Nom de famille',
            colore: 'Couleur',
            commessa: 'Projet',
            commessa_duplicata: 'Projet dupliqué avec succès!',
            commessa_eliminata: 'Projet supprimé avec succès!',
            commessa_ricevuta: 'Projet reçu',
            commessa_risorsa_aggiornata: 'Projet mis à jour avec succès!',
            commesse_importate: 'Projets importés avec succès',
            concludi: 'Conclure',
            conferma: 'Confirmer',
            conferma_eliminazione: 'Êtes-vous sûr de vouloir supprimer le projet sélectionné?',
            costo_finale: 'Coût final',
            crea: 'Créer',
            creatoIl: 'Créé le',
            creazione_eseguita: 'Création effectuée avec succès!',
            data: 'Date',
            data_fine: 'Date de fin',
            data_fine_maggiore_data_inizio:
                'La date de fin doit être postérieure à la date de début',
            data_fine_stimata: 'Date de fin estimée',
            data_inizio: 'Date de début',
            data_intervento: "Date d'intervention",
            data_nascita: 'Date de naissance',
            data_ultimo_login: 'Dernière connexion',
            dati_non_disponibili: 'Données non disponibles',
            dati_personali: 'Données personnelles',
            da_pianificare: 'À planifier',
            denominazione: 'Dénomination',
            descrizione: 'Description',
            dettagli_base: 'Détails de base',
            di: 'de',
            dipendente_cliente: 'Employé client',
            durata_attuale: 'Heures actuelles',
            durata_giornata_lavorativa: 'Durée de la journée de travail',
            durata_prevista: 'Heures prévues',
            duplica_commessa: 'Dupliquer le projet',
            email: 'E-mail',
            emailResetPassInviata:
                "E-mail de réinitialisation du mot de passe envoyé à l'utilisateur spécifié.",
            email_cliente: 'E-mail client',
            email_invio_rapportino: "E-mail d'envoi du rapport",
            elimina: 'Supprimer',
            elimina_commessa: 'Supprimer le projet',
            errore: 'Erreur!',
            errore_generazione_qr: 'Erreur de génération du QR!',
            error_effettua_login: 'Connectez-vous pour continuer',
            error_sottotitolo_401:
                "<span>Nous sommes désolés, mais vous n'avez pas les autorisations nécessaires pour effectuer cette opération. <br/>Réessayez plus tard et si l'erreur persiste, contactez notre équipe technique en fournissant des détails sur l'opération. <br/>Merci pour votre compréhension et votre patience.</span>",
            error_sottotitolo_404:
                "<span>Nous nous excusons, mais la page que vous recherchez n'est pas disponible ou a été déplacée. <br/>Vérifiez l'URL et assurez-vous qu'elle est correcte. <br/>Si le problème persiste, cela peut être dû à un lien obsolète ou à une ressource supprimée.</span>",
            error_sottotitolo_generale:
                "<span>Nous sommes désolés, une erreur imprévue s'est produite lors de l'opération. <br/>Réessayez plus tard et si l'erreur persiste, contactez notre équipe technique en fournissant des détails sur l'opération. <br/>Merci pour votre compréhension et votre patience.</span>",
            error_titolo_401: 'Non autorisé',
            error_titolo_404: 'Page non trouvée',
            error_titolo_generale: 'Erreur détectée',
            error_torna_pagina_iniziale: 'Retour à la page d’accueil',
            favorite_page_pagina_rimossa: 'La page favorite a été supprimée avec succès!',
            ferma_timer: 'Arrêter le minuteur',
            file_e_documenti: 'Fichiers et documents',
            file_troppo_grande: 'Fichier trop volumineux',
            fornitura: 'Fourniture',
            genera_password: 'Générer un mot de passe',
            genera_qr: 'Générer un QR',
            gestione_orari: 'Gestion des horaires',
            grafico: 'Graphique',
            id: 'ID',
            immagine_profilo: 'Image de profil',
            immagine_profilo_aggiornata: 'Image de profil mise à jour avec succès!',
            importa: 'Importer',
            inattivita_descrizione_1: 'Une inactivité prolongée a été détectée.',
            inattivita_descrizione_2: 'Pour des raisons de sécurité, vous avez été déconnecté.',
            inattivita_titolo: 'Inactivité détectée!',
            indirizzo_ip: 'Adresse IP',
            indirizzo_luogo_intervento: "Adresse du lieu d'intervention",
            informazione: 'Information',
            inserisci_mail_valida: 'Saisissez une adresse e-mail valide',
            invia_credenziali: 'Envoyer les identifiants par e-mail',
            invia_file: 'Envoyer un fichier',
            invia_rapportino: 'Envoyer un rapport',
            inviata_amministrazione: "Envoyé à l'administration",
            inviata_cliente: 'Envoyé au client',
            km_percorsi: 'Km parcourus',
            livello: 'Niveau',
            lista: 'Liste',
            login_aggiorna_accedi: 'Mettre à jour et se connecter',
            login_attendi: 'Veuillez patienter...',
            login_attendi_riprova: 'Veuillez patienter pour réessayer!',
            login_benvenuto: 'Bienvenue!',
            login_campo_non_sicuro: 'Champ non sécurisé!',
            login_campi_obbligatori:
                'Saisissez à la fois le nom d’utilisateur et le mot de passe pour continuer',
            login_codice_scaduto: 'Code expiré! Réessayez pour continuer',
            login_conferma_password: 'Confirmer le mot de passe',
            login_controlla_mail: 'Vérifiez vos e-mails pour continuer',
            login_effetta_accesso: 'Connectez-vous',
            login_email_reset_pass_inviata:
                "E-mail de réinitialisation du mot de passe envoyé à l'utilisateur spécifié.",
            login_livello_sicurezza_password: 'Niveau de sécurité du mot de passe',
            login_password: 'Mot de passe',
            login_password_dimenticata: 'Mot de passe oublié?',
            login_password_non_uguali: 'Les mots de passe ne correspondent pas',
            login_reset_password: 'Réinitialiser le mot de passe',
            login_submit_text: 'Se connecter',
            login_suggerimenti_password: 'Conseils pour le mot de passe',
            login_suggerimenti_password_1:
                'Le mot de passe doit contenir au moins une lettre minuscule',
            login_suggerimenti_password_2:
                'Le mot de passe doit contenir au moins une lettre majuscule',
            login_suggerimenti_password_3: 'Le mot de passe doit contenir au moins un chiffre',
            login_suggerimenti_password_4:
                'Le mot de passe doit contenir au moins un caractère spécial',
            login_suggerimenti_password_5: 'Le mot de passe doit contenir au moins 8 caractères',
            login_timeout_codice: 'Code de vérification expiré',
            login_troppe_richieste: 'Vous avez effectué trop de demandes!',
            login_usa_password: 'Utilisez votre mot de passe',
            login_username: "Nom d'utilisateur",
            login_username_reset_password:
                "Saisissez le nom d'utilisateur pour lequel vous souhaitez demander la réinitialisation du mot de passe dans le champ 'nom d'utilisateur'.",
            login_utente_non_trovato: "Impossible de trouver l'utilisateur saisi!",
            logout_conferma_disconnessione: 'Confirmer',
            logout_disconnetti: 'Se déconnecter',
            logout_disconnessione: 'Déconnexion',
            logout_messaggio_disconnessione: 'Êtes-vous sûr de vouloir vous déconnecter?',
            luogo_intervento: 'Lieu d’intervention',
            menu_amministratori: 'Administrateurs',
            menu_amministratori_tooltip: 'Annuaires - Administrateurs',
            menu_anagrafiche: 'Annuaires',
            menu_utilita_calendario_eventi: 'Calendrier des événements',
            menu_utilita_calendario_eventi_tooltip: 'Utilitaires - Calendrier des événements',
            menu_categorie_commesse: 'Catégories de projets',
            menu_categorie_commesse_tooltip: 'Annuaires - Catégories de projets',
            menu_tipologia_operatori: "Catégories d'utilisateurs",
            menu_tipologia_operatori_tooltip: "Annuaires - Catégories d'utilisateurs",
            menu_clienti: 'Clients',
            menu_clienti_tooltip: 'Annuaires - Clients',
            menu_commesse: 'Projets',
            menu_commesse_anagrafiche: 'Annuaires des projets',
            menu_commesse_pianificazione: 'Planification',
            menu_commesse_pianificazione_tooltip: 'Projets - Planification',
            menu_commesse_resoconto: 'Rapport',
            menu_commesse_resoconto_risorse: 'Rapport des collaborateurs',
            menu_commesse_anagrafiche_tooltip: 'Projets - Annuaires',
            menu_commesse_resoconto_risorse_tooltip: 'Projets - Rapport des collaborateurs',
            menu_commesse_resoconto_tooltip: 'Projets - Rapport',
            menu_dashboard: 'Tableau de bord',
            menu_impostazioni: 'Paramètres',
            menu_occupazione: 'Occupation',
            menu_priorita_commesse: 'Priorités des projets',
            menu_priorita_commesse_tooltip: 'Annuaires - Priorités des projets',
            menu_rapportini: 'Rapports',
            menu_rapportini_nuovo: 'Créer un nouveau',
            menu_rapportini_nuovo_tooltip: 'Rapports - Créer un nouveau',
            menu_rapportini_resoconto: 'Rapport',
            menu_rapportini_resoconto_tooltip: 'Rapports - Rapport',
            menu_risorse: 'Collaborateurs',
            menu_risorse_tooltip: 'Annuaires - Collaborateurs',
            menu_sconti: 'Remises',
            menu_sconti_tooltip: 'Annuaires - Remises',
            menu_tag_commesse: 'Tags des projets',
            menu_tag_commesse_tooltip: 'Annuaires - Tags des projets',
            menu_utilita: 'Utilitaires',
            menu_utilita_archivio: 'Archive',
            menu_utilita_archivio_tooltip: 'Utilitaires - Archive',
            menu_utilita_chat: 'Chat',
            menu_utilita_chat_tooltip: 'Utilitaires - Chat',
            menu_utilita_log: 'Journal',
            menu_utilita_log_tooltip: 'Utilitaires - Journal',
            messaggio_conferma_eliminazione_selezionati: 'Données supprimées avec succès!',
            messaggio_conferma_ripristino_selezionati: 'Données restaurées avec succès!',
            messaggio_duplicazione: 'Dupliquer le projet?',
            messaggio_eliminazione: 'Supprimer le projet?',
            messaggio_eliminazione_selezionati:
                'Êtes-vous sûr de vouloir supprimer les données sélectionnées?',
            messaggio_ripristina_selezionati:
                'Êtes-vous sûr de vouloir restaurer les données sélectionnées?',
            messaggio_eliminato: 'Message supprimé',
            modifica: 'Modifier',
            mostra_dettagli: 'Afficher les détails',
            mostra_ore: 'Afficher les heures',
            nessuna_chat_selezionata: 'Aucun chat sélectionné',
            nessuna_email_cliente: 'Aucun e-mail disponible pour le client sélectionné',
            nessun_cliente_selezionato: 'Aucun client sélectionné',
            nessun_dato_archiviato: "Aucune donnée marquée comme archivée n'est disponible",
            nominativo: 'Nom complet',
            nominativo_cliente: 'Nom complet du client',
            nominativo_dipendente: "Nom complet de l'employé client",
            nome: 'Prénom',
            non_programmato: 'Non programmé',
            note: 'Notes',
            note_amministrative: 'Notes administratives',
            note_intervento: "Notes d'intervention",
            numero: 'Numéro',
            numero_documento: 'Numéro de document',
            oggi: "Aujourd'hui",
            occupazione: 'Occupation',
            ore_effettive: 'Heures effectives',
            ore_lavorate: 'Heures travaillées',
            ore_lavorate_breve: 'heures trav.',
            ore_lavorate_breve_header: 'Heures trav.',
            ore_lavorate_effettive: 'Heures travaillées effectives',
            ore_lavorate_effettive_breve_header: 'Heures eff.',
            ore_viaggio: 'Heures de voyage',
            oppure: 'ou',
            parametri: 'Paramètres',
            password: 'Mot de passe',
            password_aggiornata: 'Mot de passe mis à jour avec succès!',
            password_cambiata: 'Mot de passe changé avec succès!',
            password_gia_usata:
                'Le mot de passe a déjà été utilisé précédemment! Veuillez en saisir un autre pour continuer.',
            percentuale_completamento: 'Progression',
            pianificazione: 'Planification',

            privacy_policy: `<h1>INFORMATIONS POUR LE TRAITEMENT DES DONNÉES</h1>
      
            <p>Cette page décrit les modalités de gestion du site en relation avec le traitement des données personnelles des utilisateurs qui le consultent, ainsi que les modalités et finalités du traitement des données personnelles.</p>
      
            <p>Ces informations sont également fournies conformément à l'art. 13-14 Règlement UE 2016/679 à ceux qui interagissent avec les services Web accessibles électroniquement à partir de l'adresse.</p>
      
            <p>Les informations sont fournies uniquement pour le site en question et non pour d'autres sites Internet éventuellement consultés via nos liens, dont il n'est en aucun cas responsable.</p>
      
            <p>
      
              En qualité de responsable du traitement de vos données personnelles, conformément et aux fins du règlement UE 2016/679 - RGPD, nous vous informons que la législation susmentionnée prévoit la protection des personnes concernées en ce qui concerne
      
              traitement des données personnelles et que ce traitement sera basé sur les principes de régularité, de licéité, de transparence et de protection de votre vie privée et de vos droits.
      
            </p>
      
            <p>Vos données personnelles seront traitées conformément aux dispositions législatives du règlement susmentionné et aux obligations de confidentialité qui y sont prévues.</p>
      
            <h2>TYPES DE DONNÉES TRAITÉES</h2>
      
            Données de navigation
      
            <p>
      
              Les systèmes informatiques et les procédures logicielles utilisés pour faire fonctionner ce site Web acquièrent, au cours de leur fonctionnement normal, certaines données personnelles dont la transmission est implicite dans l'utilisation de protocoles de communication.
      
              Communication Internet. Ces informations ne sont pas collectées pour être associées à des parties intéressées identifiées, mais de par leur nature même, elles pourraient, par le biais de traitements et d'associations avec des données détenues par des tiers,
      
              permettre à
      
                  permettre l'identification des utilisateurs. Cette catégorie de données comprend les adresses IP ou les noms de domaine des ordinateurs utilisés par les utilisateurs qui se connectent au site, les adresses URI (Uniform Resource Identifier),
      
                  Identifiant) des ressources demandées, l'heure de la requête, la méthode utilisée pour soumettre la requête au serveur, la taille du fichier obtenu en réponse, le code numérique indiquant l'état de la réponse donnée par le
      
                  serveur (réussite, erreur, etc.) et d'autres paramètres relatifs au système d'exploitation et à l'environnement informatique de l'utilisateur. Ces données sont utilisées dans le seul but d'obtenir des informations statistiques anonymes sur l'utilisation du site et pour
      
                  vérifier qu'ils fonctionnent correctement et sont supprimés immédiatement après traitement. Les données pourraient être utilisées pour déterminer les responsabilités en cas d'hypothétiques délits informatiques contre le site.
      
                </p>
      
                <h3>Données fournies volontairement par l'utilisateur</h3>
      
                <p>
      
                  L'envoi facultatif, explicite et volontaire de courrier électronique aux adresses indiquées sur ce site, ainsi que le remplissage des formulaires d'envoi de demandes spécifiques, entraînent l'acquisition ultérieure de l'adresse du
      
                  l'expéditeur, nécessaires pour répondre aux demandes, ainsi que toutes autres données personnelles incluses dans le message ou le formulaire.
      
                  <br />Des informations récapitulatives spécifiques sont rapportées ou affichées sur les pages du site mises en place pour des services particuliers sur demande.
      
                </p>
      
                <h2>CONSÉQUENCES DU REFUS DE FOURNIR DES DONNÉES</h2>
      
                <p>
      
                  En dehors de ce qui est spécifié pour les données de navigation, l'utilisateur est libre de fournir les données personnelles signalées dans les formulaires de demande, pour l'inscription aux listes de diffusion ou dans tous les cas indiquées dans les contacts pour demander l'envoi de matériel.
      
                  communications informatives, techniques ou commerciales ou autres. Le fait de ne pas les fournir peut rendre impossible l’obtention de ce qui a été demandé.
      
                </p>
      
                <h2>MÉTHODES DE TRAITEMENT</h2>
      
                <p>
      
                  Les données sont traitées principalement avec des outils électroniques et informatiques et conservées aussi bien sur des supports informatiques que sur des supports papier et sur tout autre type de support approprié, conformément aux modalités prévues dans les articles.
      
                  6, 32 du RGPD et par l’adoption des mesures de sécurité appropriées prévues. pour empêcher la perte de données, l’utilisation illicite ou incorrecte et l’accès non autorisé.
      
                </p>
      
                <p>
      
                  Nous vous informons que, afin de fournir un service complet, notre portail peut contenir des liens vers d'autres sites Web, non gérés par nous. Nous ne sommes pas responsables des erreurs, contenus, cookies, publications de contenu moral illicite,
      
                  publicités, bannières ou fichiers non conformes à la législation en vigueur et au respect de la législation sur la confidentialité par les sites que nous gérons auxquels il est fait référence. Afin d'améliorer le service offert, une réponse immédiate est appréciée.
      
                  signaler des dysfonctionnements, des abus ou des suggestions à l'adresse email. Vos données seront traitées uniquement par du personnel expressément autorisé par le Responsable du traitement.
      
                </p>
      
                <h2>OBJECTIF DU TRAITEMENT</h2>
      
                <p>
      
                  Le traitement des données sera effectué pour :
      
                  <br />- donner la possibilité d’accéder aux sections publiques et/ou réservées du site ; <br />- effectuer l'activation et la maintenance de tous services souscrits en ligne ; <br />- exécuter les obligations prévues par
      
                  lois ou règlements; <br />- la protection du Propriétaire en justice ; <br />- envoyer du matériel informatif à caractère commercial ou promotionnel <br />- permettre un suivi constant de l'efficacité du service proposé.
      
                </p>
      
                <h2>SUJETS AUXQUELS LES DONNÉES PERSONNELLES PEUVENT ÊTRE COMMUNIQUÉES</h2>
      
                <p>
      
                  Les données personnelles relatives au traitement en question pourront également être communiquées aux sujets qui sont reconnus comme ayant le droit d'accéder à vos données personnelles par la loi ou par des réglementations secondaires et/ou communautaires.
      
                  Par ailleurs, certaines données pourront être communiquées et diffusées aux opérateurs Internet chargés de gérer leurs domaines. La diffusion des données collectées n'est pas prévue.
      
                </p>
      
                <h2>DURÉE DE CONSERVATION DES DONNÉES</h2>
      
                <p>
      
                  Nous vous informons que, dans le respect des principes de licéité, de limitation des finalités et de minimisation des données, conformément à l'art. 5 du RGPD, la durée de conservation de vos données personnelles est de 15 ans. À l’expiration du
      
                  Après la période de conservation susmentionnée, les données personnelles seront automatiquement supprimées.
      
                </p>
      
                <h2>DROITS DES PARTIES INTÉRESSÉES</h2>
      
                <p>Règlement UE 2016/679 : Art. 15, 16, 17, 18, 19, 20, 21, 22 - Droits de la personne intéressée
      
                <p>1. L'intéressé a le droit d'obtenir la confirmation de l'existence ou non de données personnelles le concernant, même si elles ne sont pas encore enregistrées, et leur communication sous une forme intelligible.
      
                <p>
      
                  2. L'intéressé a le droit d'obtenir l'indication :
      
                  <br />a. de l’origine des données personnelles ; <br />b. des finalités et des modalités du traitement ; <br />c. de la logique appliquée en cas de traitement effectué à l’aide d’instruments électroniques ; <br />d. des extrêmes
      
                  les données d'identification du propriétaire, des gestionnaires et du représentant désigné conformément à l'article 5, paragraphe 2 ; <br />et. des sujets ou catégories de sujets auxquels les données personnelles peuvent être communiquées ou qui peuvent
      
                  en prendre connaissance en qualité de représentant désigné sur le territoire de l'Etat, en qualité de gérants ou de mandataires.
      
                </p>
      
                <p>
      
                  3. L'intéressé a le droit d'obtenir :
      
                  <br />a. la mise à jour, la rectification ou, lorsqu'il y a intérêt, l'intégration des données ; <br />b. l'annulation, la transformation sous forme anonyme ou le blocage des données traitées en violation de la loi, y compris celles
      
                  dont la conservation n’est pas nécessaire au regard des finalités pour lesquelles les données ont été collectées ou traitées ultérieurement ; <br />c. la certification que les opérations visées aux lettres a) et b) ont été portées à la connaissance de,
      
                  également en ce qui concerne leur contenu, de ceux à qui les données ont été communiquées ou diffusées, sauf dans le cas où une telle réalisation se révèle impossible ou comporte l'utilisation de moyens <br />d. manifestement
      
                  disproportionné par rapport au droit protégé ; <br />et. portabilité des données.
      
                </p>
      
                <p>
      
                  4. L'intéressé a le droit de s'opposer, en tout ou en partie :
      
                  <br />a. pour des motifs légitimes au traitement des données à caractère personnel le concernant, même si elles sont pertinentes au regard des finalités de la collecte ; <br />b. au traitement des données personnelles le concernant aux fins d'envoi de matériel publicitaire ou
      
                  pour la vente directe ou pour effectuer des recherches <br />c. communication de marché ou commerciale
      
                </p>
      
                <p>
      
                  L'utilisateur a le droit d'obtenir du propriétaire l'annulation (droit à l'oubli), la limitation, la mise à jour, la rectification, la portabilité, l'opposition au traitement des données personnelles le concernant, ainsi que dans
      
                  général peut exercer tous les droits prévus par l'art. 15, 16, 17, 18, 19, 20, 21, 22 du RGPD.
      
                </p>
      
                <p>Pour exercer les droits énumérés ci-dessus, l'intéressé doit envoyer une demande écrite par courrier électronique.</p>
      
                <p></p>
      
                <h2>COOKIES</h2>
      
                <p>
      
                  Les cookies sont de petits fichiers texte qui sont placés sur le disque dur d'un ordinateur ou d'un autre appareil par le fournisseur de services en ligne pour les visiteurs du site Web. Les cookies peuvent collecter des informations sur votre
      
                  les habitudes des visiteurs concernant l'utilisation du site Internet susmentionné, en enregistrant les activités de leur ordinateur ou autre appareil concernant le site susmentionné, par exemple lorsqu'il s'agit d'effectuer des achats.
      
                </p>
      
                <h3>Les COOKIES peuvent être :</h3>
      
                <h3>Cookies propriétaires (également appelés cookies propriétaires)</h3>
      
                <p>Les cookies propriétaires sont des cookies qui sont enregistrés directement sur votre ordinateur ou autre appareil. Ils peuvent inclure des cookies tels que des cookies de session et des cookies persistants (décrits ci-dessous).</p>
      
                <p>Les cookies propriétaires peuvent être utilisés pour suivre les mouvements de l'ordinateur ou d'un autre appareil du visiteur lors de la consultation du site, par exemple à des fins d'analyse.</p>
      
                <h3>Cookie de l'autre côté</h3>
      
                <p>Aucun cookie tiers n'est stocké</p>
      
                <h3>Cookie de session</h3>
      
                <p>
      
                  Le temps entre le moment où vous ouvrez votre navigateur Internet et celui où vous le fermez est appelé une session de navigation. Les cookies de session sont des cookies stockés sur votre ordinateur ou autre appareil.
      
                  visiteur lors d'une session de navigation, mais qui expirent et sont normalement supprimés à la fin d'une session de navigation.
      
                </p>
      
                <h3>Cookie persistant</h3>
      
                <p>
      
                  Les cookies persistants sont des cookies stockés sur l'ordinateur ou autre appareil du visiteur pendant une session de navigation, mais qui restent sur l'ordinateur ou autre appareil après la fin de la session de navigation.
      
                  (par exemple, l'enregistrement du mot de passe). Les cookies persistants permettent aux sites de reconnaître l'ordinateur ou un autre appareil du visiteur lorsqu'il est utilisé pour accéder à nouveau à l'un de nos sites, après la fin d'une session.
      
                  navigation et au début d'une nouvelle session de navigation, essentiellement pour aider le visiteur à se reconnecter rapidement à notre site.
      
                </p>
      
                <p>
      
                  Ce site, pour des raisons strictement techniques, utilise les types de cookies suivants :
      
                  <br />- des cookies techniques et de session, par exemple pour éviter - le cas échéant - à l'utilisateur de devoir saisir plusieurs fois le mot de passe pour accéder aux sections réservées du site, ou pour mémoriser la langue de navigation préférée, ou
      
                  pour stocker certaines caractéristiques techniques du navigateur utilisé pour la navigation (y compris l'acceptation des cookies).
      
                </p>
      
                <p>Il est possible de désactiver l'utilisation des cookies, mais choisir une telle option est susceptible de provoquer un dysfonctionnement du site, plus ou moins évident selon la section du site que vous comptez visiter.</p>
      
                <p>Pour désactiver les cookies, selon le navigateur utilisé, nous pouvons vous proposer quelques guides (valables au moment de la rédaction de ce document).</p>
      
                <h3>Chrome</h3>
      
                <p>1. Exécutez le navigateur Chrome</p>
      
                <p>2. Cliquez sur le menu de la barre d'outils du navigateur à côté de la zone de saisie d'URL pour la navigation</p>
      
                <p>3. Sélectionnez Paramètres</p>
      
                <p>4. Cliquez sur Afficher les paramètres avancés</p>
      
                <p>5. Dans la section « Confidentialité » section cliquez sur « Paramètres de contenu » bouton</p>
      
                <p>6. Dans les « Cookies » section Vous pouvez modifier les paramètres de cookies suivants :</p>
      
                <ul>
      
                  <li>Autoriser l'enregistrement des données locales</li>
      
                  <li>Modifier les données locales uniquement jusqu'à la fermeture du navigateur</li>
      
                  <li>Empêcher les sites de définir des cookies</li>
      
                  <li>Bloquer les cookies tiers et les données du site</li>
      
                  <li>Gérer les exceptions pour certains sites Web</li>
      
                  <li>Supprimer un ou tous les cookies</li>
      
                </ul>
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://support.google.com/accounts/answer/61416?hl=it" target="_blank">page dédiée</a>.
      
                </p>
      
                <h3>Mozilla Firefox</h3>
      
                <p>1. Exécutez le navigateur Mozilla Firefox</p>
      
                <p>2. Cliquez sur le menu de la barre d'outils du navigateur à côté de la zone de saisie d'URL pour la navigation</p>
      
                <p>3. Sélectionner les options</p>
      
                <p>4. Sélectionnez le panneau Confidentialité</p>
      
                <p>5. Cliquez sur Afficher les paramètres avancés</p>
      
                <p>6. Dans la section « Confidentialité » section cliquez sur « Paramètres de contenu » bouton</p>
      
                <p>7. Dans le « Suivi » section Vous pouvez modifier les paramètres de cookies suivants :</p>
      
                <ul>
      
                  <li>Demandez aux sites de ne pas vous suivre</li>
      
                  <li>Indiquez aux sites que vous acceptez d'être suivi</li>
      
                  <li>Ne communiquez aucune préférence concernant le suivi des données personnelles</li>
      
                </ul>
      
                <p>8. De l'« Histoire » section c'est possible :</p>
      
                <ul>
      
                  <li>
      
                    En activant « Utiliser les paramètres personnalisés » choisir d'accepter les cookies tiers (toujours, des sites les plus visités ou jamais) et de les conserver pendant une durée déterminée (jusqu'à leur expiration, au
      
                    fermer Firefox ou demander à chaque fois)
      
                  </li>
      
                  <li>Supprimer les cookies individuels stockés</li>
      
                </ul>
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank">page dédiée</a>.
      
                </p>
      
                Internet Explorer
      
                <p>1. Exécutez le navigateur Internet Explorer</p>
      
                <p>2. Cliquez sur le bouton Outils et choisissez Options Internet</p>
      
                <p>3. Cliquez sur l'onglet Confidentialité et dans la section Paramètres, modifiez le curseur en fonction de l'action souhaitée pour les cookies :</p>
      
                <ul>
      
                  <li>Bloquer tous les cookies</li>
      
                  <li>Autoriser tous les cookies</li>
      
                  <li>
      
                    Sélection des sites à partir desquels obtenir des cookies : déplacez le curseur vers une position intermédiaire afin de ne pas bloquer ou autoriser tous les cookies, puis appuyez sur Sites, dans la case Adresse du site Web, saisissez un site Web et
      
                    puis appuyez sur Bloquer ou Autoriser
      
                  </li>
      
                </ul>
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://support.microsoft.com/it-it/products/windows?os=windows-10" target="_blank">page dédiée</a>.
      
                </p>
      
                Safari 6/7
      
                <p>1. Exécutez le navigateur Safari</p>
      
                <p>2. Cliquez sur Safari, sélectionnez Préférences et appuyez sur Confidentialité</p>
      
                <p>3. Dans la section Bloquer les cookies, spécifiez comment Safari doit accepter les cookies des sites Web.</p>
      
                <p>4. Pour voir quels sites ont stocké des cookies, cliquez sur Détails</p>
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://support.apple.com/kb/PH17191?locale=en_US&viewlocale=it_IT" target="_blank">page dédiée</a>.
      
                </p>
      
                Safari iOS (appareils mobiles)
      
                <p>1. Exécutez le navigateur Safari iOS</p>
      
                <p>2. Appuyez sur Paramètres puis sur Safari</p>
      
                <p>3. Appuyez sur Bloquer les cookies et choisissez entre les différentes options : « Jamais », « Tiers et annonceurs » ou « Toujours »</p>
      
                <p>4. Pour supprimer tous les cookies stockés par Safari, appuyez sur Paramètres, puis sur Safari, puis sur Effacer les cookies et les données.
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://support.apple.com/it-it/HT201265" target="_blank">page dédiée</a>.
      
                </p>
      
                Opéra
      
                <p>1. Exécutez le navigateur Opera</p>
      
                <p>2. Cliquez sur Préférences puis sur Avancé et enfin sur Cookies</p>
      
                <p>3. Sélectionnez l’une des options suivantes :</p>
      
                <ul>
      
                  <li>Accepter tous les cookies</li>
      
                  <li>Acceptez uniquement les cookies du site que vous visitez : les cookies tiers et ceux envoyés depuis un domaine autre que celui que vous visitez seront rejetés</li>
      
                  <li>Ne jamais accepter les cookies : tous les cookies ne seront jamais enregistrés</li>
      
                </ul>
      
                <p>
      
                  Pour plus d'informations, visitez le
      
                  <a href="https://www.opera.com/help/tutorials/security/privacy/" target="_blank">page dédiée</a>.
      
                </p>
      
                <p>
      
                  Si le programme que vous utilisez pour naviguer sur les sites Web ne fait pas partie de ceux mentionnés ci-dessus, nous vous suggérons d'utiliser un moteur de recherche en ligne (google, yahoo, bing...) pour comprendre comment désactiver les cookies dans
      
                  ce navigateur spécifique.
      
                </p>`,

            prodotti: 'Produits',
            prodotti_relativi_ordine: 'Produits relatifs à la commande',
            prodotti_utilizzati: 'Produits utilisés',
            profilo_aggiornato: 'Profil mis à jour avec succès!',
            profilo_personale: 'Profil personnel',
            rapportini: 'Rapports',
            rapportino_inviato: 'Rapport envoyé avec succès!',
            rapportino_ricevuto: 'Rapport reçu',
            relazione_intervento: "Rapport d'intervention",
            resoconto: 'Compte rendu',
            riprendi_timer: 'Reprendre le minuteur',
            ripristina: 'Restaurer',
            risorsa: 'Collaborateur',
            risorse: 'Collaborateurs',
            salva: 'Enregistrer',
            scorciatoia_ctrl_b: 'Ouvrir/fermer le menu : CTRL + B',
            seleziona: 'Sélectionner',
            seleziona_foto: 'Sélectionner une photo',
            settimana: 'Semaine',
            settimana_attuale: 'Semaine actuelle',
            standard: 'Standard',
            stato: 'État',
            successo: 'Succès',
            su: 'sur',
            su_cosa_hai_lavorato: 'Sur quoi avez-vous travaillé?',
            telefono: 'Téléphone',
            tempo_rimanente: 'Temps restant',
            termina_modifica: 'Terminez d’abord la modification en cours!',
            testo_copiato: 'Texte copié dans le presse-papiers',
            titolo_cambio_password: 'Changement de mot de passe',
            torna_indietro: 'Retourner',
            totale_ore: 'Total des heures',
            trasferta: 'Déplacement',
            tutti_i_campi_devono_essere_compilati:
                'Tous les champs obligatoires doivent être remplis',
            url: 'URL',
            username: 'Nom d’utilisateur',
            utenti: 'Utilisateurs',
            verifica_campi: 'Vérifiez les champs saisis',
            visualizzi_da: 'Vous visualisez depuis',
            zero_ore_lavorate_breve: '0 h trav.',
        },
    },
}));
